import React, { Component } from "react";
import "./chatbot.css";
import Message from "./bot/main_render/Message";
import Card from "../chatbot/bot/bot_utility_components/Card";
import { connect } from "react-redux";
import {
  update_botStatus_inactive,
  update_botStatus_active,
} from "../../store/actions/botStatusAction";
import {
  update_botTyping_to_true,
  update_botTyping_to_false,
} from "../../store/actions/botTypingAction";
import { bot_message_added } from "../../store/actions/botMessagesLengthAction";
// import Button from '@mui/material/Button';
// import Dialog from '@mui/material/Dialog';
// import DialogActions from '@mui/material/DialogActions';
// import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';
import uuid from "react-uuid";
// import MinIframe from "./MinIframe";
import { open_modal } from "../../store/actions/modalStatusAction";
import ChatBotHeader from "./bot/main_render/ChatBotHeader";
import LoginForm from "../chatbot/bot/forms/LoginForm";
import UserSelectorModal from "../modals/UserSelectorModal";
import create_transcript_query from "../../helpers/user_query_service";
import AutoSuggestedInput from "../chatbot/bot/bot_utility_components/AutoSuggestedInput";
import {
  generate_adya_nlp_response_param,
  generate_faqMenu_response_param,
  generate_floatingMenu_response_param,
  generate_guidedMenu_response_param,
  generate_nlp_response_param,
  generate_Quick_Menu_response_param,
  generate_triggerWorkflow_response_param,
  generate_workflow_data_response_param,
  generate_SCP_WORKFLOW_data_params,
  generate_workflow_response_param,
  generate_workflow_user_select_yesorno_param,
} from "../../helpers/param_generator";
import {
  get_WorkflowResponse,
  get_doc,
  generateLeaveRequest,
  sendTranscript,
  checkIf_humanhelp,
  clearSessionStorageData,
} from "../../services/other_services";
import {
  generateDataCardMessageData,
  generateIframeMessageData,
  generateListMessagesData,
  generateTextMessageData,
  generatePdfMessage,
  generateFormMessage,
  generateStatusCardMessage,
  generateDocumentCardMessage,
  generateBotTypingData,
  generateDetailedCardMessage,
  generateActionMessageData,
  generateGuidedMenuMessageData,
  generateGuidedHeroCardMessageData,
  generateAdvertisementData,
  generateQuickMenuData,
  generateWorkflowData,
  generate_nlp_qa_MessageData,
  generateAdyaActionMessageData,
  generateMenuFaqData,
  generateAgrflowData,
  generateAgrCardMessageData,
  generateAgrflowDataDatepicker,
  generateAgrflowDataDateRange,
  generatesteflowData,
  generateWelcomeMessage,
  generateOtpValidation,
  generateMobileValidation,
  generateActionExitMessageData,
  generateActionCIFMessageData,
  generateViewAccountDetails,
  generateTermDepositEnquiry,
  generateSCPform
} from "../../helpers/message_factory";
// import {
//   form_builder_url_user,
//   form_builder_url_admin,
//   excel_export_url,
// } from "../../config";
// import LeaveRequestForm from "./forms/LeaveRequestForm";
// import {
//   get_initialization_account_balance_form_data,
//   get_initialization_leave_form_data,
// } from "../../helpers/form_services";
import {
  sendQuery,
  sendUserActivityStatus,
  sendUserChoiceYesorNo,
  sendUserVisit,
  sendWorkflowdata,
  socket1,
  triggerWorkflow,
} from "../../services/socketServices";
// import LanguageSelection from "../chatbot/bot/bot_utility_components/LanguageSelection";
// import SendIcon from "@material-ui/icons/Send";
// import { Button, Icon, IconButton } from "@material-ui/core";
// import SpeechToText from "../hermesvoice/SpeechToText";
// import JumpingDots from "../misc/JumpingDots";

import ArrowDropDownIcon from "@material-ui/icons/ArrowDownward";
import ArrowDropUpIcon from "@material-ui/icons/ArrowUpward";
import {
  getHermesTranslation,
  getTranslation,
  getTranslitration,
} from "../../services/googleTanslate_services";
// import {
//   addTranscript,
//   deleteTranscript,
// } from "../../helpers/transcript_services";
import ConfirmModal from "../modals/ConfirmModal";
import RefreshConfirmModal from "../modals/RefreshConfirmodal";
import LanguageSelector from "../modals/UserPreference";
// import { generateChatHistory } from "../../helpers/humanHandoff_helper";
// import {
//   TransferWithinAStationSharp,
//   YoutubeSearchedFor,
// } from "@material-ui/icons";
import {
  CREATE_VIDEOFLO_SESSION,
  DELETE_VIDEOFLO_SESSION,
} from "../../store/actions/videoFloActions";
// import ibLogo from "../../images/indian-bank/ib-web-ad-1.jpg";
import ibAdLogo1 from "../../images/indian-bank/1000254036.jpg";
import ibAdLogo2 from "../../images/indian-bank/1000254034.jpg";
import ibAdLogo3 from "../../images/indian-bank/1000254035.jpg";
import ibAdLogo4 from "../../images/indian-bank/1000254037.jpg";
import { ADYA_USER_QUERY_ACTION } from "../../store/actions/adyaUserQueryAction";
import RefreshConfirmodal from "../modals/RefreshConfirmodal";
import UserPreference from "../modals/UserPreference";
import JumpingDots from "../misc/JumpingDots";
// import EventEmitter from 'eventemitter3';

import eventBus from "./EventBus";
import EventBus from "./EventBus";
class Chatbot_Talk_To_Bot extends Component {
  messagesEnd = "";
  constructor(props) {
    super(props);
    // this.eventEmitter = new EventEmitter()
    this._handleInputKeyPress = this._handleInputKeyPress.bind(this);
    this.refeshChatbot = this.refeshChatbot.bind(this);
    this.scrollToBottom = this.scrollToBottom.bind(this);
    this._handleSendButton = this._handleSendButton.bind(this);
    this.onhandleSendButton = this.onhandleSendButton.bind(this);
    //TEST START
    this.onResetInputField = this.onResetInputField.bind(this);
    //TEST End
    this._handleKeyUp = this._handleKeyUp.bind(this);
    this.df_text_query = this.df_text_query.bind(this);
    this.setUserInput = this.setUserInput.bind(this);
    // this.add_user_query_to_bot = this.add_user_query_to_bot.bind(this);
    this.setUserVisit = this.setUserVisit.bind(this);
    this.setUserAcitivtyStatus = this.setUserAcitivtyStatus.bind(this);
    // this.setWelcomeMessage = this.setWelcomeMessage.bind(this);
    this.setBotGreeting = this.setBotGreeting.bind(this);
    // this.handleLanguageSelect = this.handleLanguageSelect.bind(this);
    // this.handleCloseLanguageSelector = this.handleCloseLanguageSelector.bind(this);
    // this.languageSelectorOpen = this.languageSelectorOpen.bind(this);

    this.setFloatingWelcomeMenu = this.setFloatingWelcomeMenu.bind(this);
    this.setFloatingQuickMenu = this.setFloatingQuickMenu.bind(this);
    this.setWelcomeAds = this.setWelcomeAds.bind(this);
    this.getFeedback = this.getFeedback.bind(this);
    this.onClickGuidedMenuHandler = this.onClickGuidedMenuHandler.bind(this);
    this.onClickQuickMenuHandler = this.onClickQuickMenuHandler.bind(this);
    this.onSendUpcomingMessage = this.onSendUpcomingMessage.bind(this);
    this.onTypedMenuHandler = this.onTypedMenuHandler.bind(this);
    // TEST Start
    this.faqMenuHandler = this.faqMenuHandler.bind(this);
    // TEST End
    this.onClickTriggerWorkflow = this.onClickTriggerWorkflow.bind(this);
    this.onTypedTriggerWorkflow = this.onTypedTriggerWorkflow.bind(this);
    this.onSendWorkflowData = this.onSendWorkflowData.bind(this);
    this.handleLanguageChange = this.handleLanguageChange.bind(this);
    this.onGetAccountListNoData = this.onGetAccountListNoData.bind(this);
    this.onUserSelectYesorNo = this.onUserSelectYesorNo.bind(this);
    this.setWorkflowState = this.setWorkflowState.bind(this);
    this.setWorkflowSelected = this.setWorkflowSelected.bind(this);
    this.setWorkflowActivityId = this.setWorkflowActivityId.bind(this);
    this.setUserSelectYesorNo = this.setUserSelectYesorNo.bind(this);
    this.setWorkFlowExitYesorNo = this.setWorkFlowExitYesorNo.bind(this);
    this.setCIFWorkflowYesorNo = this.setCIFWorkflowYesorNo.bind(this);
    // this.setUserServiceChanger=this.setUserServiceChanger.bind(this)
    this.setChatBOTFooterState = this.setChatBOTFooterState.bind(this);
    this.createMessage = this.createMessage.bind(this);
    this.setMessages = this.setMessages.bind(this);
    this.setMenuMessages = this.setMenuMessages.bind(this);
    this.setAdsMessages = this.setAdsMessages.bind(this);
    this.setmicBusy = this.setmicBusy.bind(this);
    this.generateSpeech = this.generateSpeech.bind(this);
    this.addTypingBubble = this.addTypingBubble.bind(this);
    this.setTempMessages = this.setTempMessages.bind(this);
    this.removeTempMessages = this.removeTempMessages.bind(this);
    this.renderTempMessage = this.renderTempMessage.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
    // this.onRefresh=this.onRefresh.bind(this)
    // this.setServiceChanger=this.setServiceChanger(this)
    this.onCancel = this.onCancel.bind(this);
    this.bot_event_handler = this.bot_event_handler.bind(this);
    this.setGuidedMessages = this.setGuidedMessages.bind(this);
    this.getFromLastGuidedMenu = this.getFromLastGuidedMenu.bind(this);
    this.getUserQueryNlp = this.getUserQueryNlp.bind(this);
    this.onSendSCPWorkFlowData = this.onSendSCPWorkFlowData.bind(this)
    // this.onSendSCPWorkFlowData = this.onSendSCPWorkFlowData.bind(this)
    this.setRateModalActive = this.setRateModalActive.bind(this);

    this.state = {
      // hasagrstarted: false,
      //change state for RBIH -> ADYA
      languageModalIsOpen: false,
      isDarkMode: false,
      isfontSize: "",
      // isfontState: false,
      messages: [],
      // workflowCustomMessages: [],
      menuMessages: [],
      guidedMenuMessages: null,
      userQueryNlp: null,
      inputValue: "",
      adsDataList: [],
      tempMessages: [],
      customMessages: [],
      openMenu: false,
      autosuggestions: [],
      suggestions: [],
      is_mounted: false,
      inputHistory: [],
      inputPointer: 0,
      // lazyLoders: { login_process: false },
      userInput: "",
      workflow_status: false,
      workflow_activity_id: 0,
      workflow_name: "",
      user_activity_status: "",
      user_activity_id: 0,
      user_select: "",
      workflow_id: null,
      isWorkflowEnabled: false,
      chatBOTFooterDisable: false,
      micBusy: false,
      micText: "",
      previousQuery: "",
      isRateModalActive: false,
      selectedSuggestionIndex: -1,
      languageSelector: false,
      languageSelectorOpen: false,
      refreshConfirmOpen: false,
      ConfirmUserPreference: false,
      //hardcoded if languageModalIsOpen is false "" -> "en"
      selectedLanguage: "en",
      isMounted: false,
      showPopup: false,
      firstload: false,
      inputClicked: false,
      footerBackground: false,
      loadingDots: false,
      tempImpMsg: "",
      // open: false,
      onWorkflowChange: null,
    };
  }
  onMessageHandler = (event) => {
    const { data } = event;
    if (data && data.type === "reload") {
      this.reloadChatbox();
    }
  };

  reloadChatbox = () => {
    // Your logic for reloading the chatbox goes here
    sessionStorage.clear();
    localStorage.clear();
    // Clear cookies, reload the page, etc.
  };
  disableRightClick = (e) => {
    e.preventDefault();
  };

  handleInputClick = () => {
    if (
      this.state.firstload &&
      !this.state.inputClicked &&
      !this.state.workflow_activity_id
    ) {
      this.setState({ inputClicked: true, chatBOTFooterDisable: false });
      //change this state for pop up removal RBIH -> ADYA
      this.setState({ showPopup: false });
    }
  };

  handleClosePopup = () => {
    this.setState({ showPopup: false });
  };
  //  handleClose = () => {
  //   setOpen(false);
  // };

  // handleYes = () => {
  //   setOpen(false);
  //   // Perform the actions when "Yes" is clicked
  //  this.reloadChatbox();
  //       this.props.update_botStatus_inactive();
  //       this.props.resetLoginStatus();
  // };
  // refreshconfirmmodal=()=>{
  //   this.reloadChatbox();
  //   this.props.update_botStatus_inactive();
  //   this.props.resetLoginStatus();
  //   this.setState({refreshConfirmOpen:false})

  // }
  onRefreshCancel = () => {
    this.setState({ refreshConfirmOpen: false });
  };
  onRefreshConfirm = () => {
    window.parent.postMessage("refresh", "*");
  };
  onUserPreferenceCancel = () => {
    this.setState({ ConfirmUserPreference: false });
  };
  onUserPreferenceConfirm = () => {
    this.setFloatingQuickMenu(this.state.selectedLanguage);
    this.setFloatingWelcomeMenu(this.state.selectedLanguage);
    this.setState({
      ConfirmUserPreference: false,
      messages: [],
      isWorkflowEnabled: false,
    });
  };
  workflowDataHandler = (otp) => {
    this.df_text_query(`${otp}`);
  };

  handleYesClick = (e) => {
    console.log("E", e);
    // Handle the yes option
    this.setState({ showPopup: false, isWorkflowEnabled: true });
    this.handleClosePopup();
    // if (this.state.languageModalIsOpen) {
    if (this.state.selectedLanguage === "en") {
      this.onClickTriggerWorkflow("ebc-909", "Excess Bank Charges", "workflow");
    } else if (this.state.selectedLanguage === "hn") {
      this.onClickTriggerWorkflow("ebc-909", "अतिरिक्त बैंक शुल्क", "workflow");
    } else if (this.state.selectedLanguage === "od") {
      this.onClickTriggerWorkflow("ebc-909", "ଅଧିକ ବ୍ୟାଙ୍କ ଦେୟ |", "workflow");
    }
    // }
  };

  // lYesClick = (e) => {
  //   console.log("E",e);
  //   // Handle the yes option
  //   this.setState({ showPopup: false,isWorkflowEnabled:true });
  //   this.handleClosePopup();
  //   this.onClickTriggerWorkflow("ebc-909","Excess Bank Charges","workflow")
  // };

  handleNoClick = (e) => {
    console.log("E", e);
    // Handle the no option
    this.setState({ showPopup: false });
    this.handleClosePopup();
  };
  // handleLanguageSelect = (language) => {
  //   this.setState({ selectedLanguage: language });
  // };

  // handleOpenLanguageSelector = () => {
  //   this.setState({ languageSelectorOpen: true });
  // };

  // handleCloseLanguageSelector = () => {
  //   this.setState({ languageSelectorOpen: false });
  // };
  handleScrollButtonClick = () => {
    this.toggleScrollFunctionality();
  };

  // handleLanguageSelect = (languages) => {
  //   this.setState({ConfirmUserPreference:true})
  //   // {this.state.refreshConfirmOpen && (
  //   //   <RefreshConfirmModal
  //   //     // onRefreshConfirm={this.onRefreshConfirm}
  //   //     // onRefreshCancel={this.onRefreshCancel}
  //   //     onMessage={[ "Please confirm ,the data will be lost"]} // Send messages as an array

  //   //   // onConfirm={this.onConfirm}
  //   //   // onMinimize={function () {
  //   //   //   this.props.update_botStatus_inactive();
  //   //   //   this.props.toggleConfirmModal(false);
  //   //   // }.bind(this)}
  //   //   // onCancel={function () {
  //   //   //   // console.log("onCancel clicked");
  //   //   //   // this.props.toggleConfirmModal(false);
  //   //   //   this.setState({ refreshConfirmOpen: false });
  //   //   // }.bind(this)}
  //   //   />

  //   //   // ></RefreshConfirmModal.>
  //   // )}

  //   // <RefreshConfirmModal/>
  //   // setTimeout(() => {

  //   //   this.setBotGreeting(languages.language)
  //   // }, 0);
  //   // // this.setState({messages: []})
  //     console.log(languages.language,languages.fontSize,languages.theme)
  //     // this.setBotGreeting()
  //   this.setState(
  //     { selectedLanguage: languages.language,languageModalIsOpen: false },
  //     () => {

  //       // this.setFloatingQuickMenu(languages.language);
  //       // this.setFloatingWelcomeMenu(languages.language)
  //     }
  //   )

  //   if (languages.theme == "LIGHT THEME") {

  //     this.setState({ isDarkMode: false });
  //   }
  //   if (languages.theme == "DARK THEME") {

  //     this.setState({ isDarkMode: true });

  //   }
  //   if(languages.fontSize==="small"){
  //     if (this.state.isfontSize !== 'small') {
  //       this.setState({
  //           isfontSize: 'small',
  //           isfontState: true
  //       }, () => {
  //           console.log(this.state.isfontSize);
  //           this.setMessages(generateTextMessageData("", "bot", this.state.isfontSize));
  //       });
  //   }

  //   }
  //   if (languages.fontSize == "medium") {
  //     if (this.state.isfontSize !== 'medium') {

  //       this.setState({
  //           isfontSize: 'medium',
  //           isfontState: true
  //       }, () => {
  //           console.log(this.state.isfontSize);
  //           this.setMessages(generateTextMessageData("", "bot", this.state.isfontSize));
  //       });
  //   }
  //     // console.log("medium");
  //     // this.setState({ isfontSize:'medium'});

  //     // console.log(this.state.isfontSize)

  //     // this.setState({isfontState:true})
  //     // this.setMessages(generateTextMessageData("","bot",this.state.isfontSize))
  //   }
  //   if (languages.fontSize == "large") {
  //     // console.log("large");
  //     // this.setState({ isfontSize: "large"});
  //     // this.setState({isfontState:false})
  //     // this.setMessages(generateTextMessageData("","bot",this.state.isfontSize))
  //     if (this.state.isfontSize !== 'large') {

  //       this.setState({
  //           isfontSize: 'large',
  //           isfontState: true
  //       }, () => {

  //           this.setMessages(generateTextMessageData("", "bot", this.state.isfontSize));
  //       });
  //   }

  //   }

  // };
  handleLanguageSelect = (languages) => {
    this.setState({
      selectedLanguage: languages.language,
      languageModalIsOpen: false,
    });

    if (languages.theme == "LIGHT THEME") {
      this.setState({ isDarkMode: false });
    }
    if (languages.theme == "DARK THEME") {
      this.setState({ isDarkMode: true });
    }
    if (languages.fontSize === "small") {
      if (this.state.isfontSize !== "small") {
        this.setState(
          {
            isfontSize: "small",
          },
          () => {
            this.setMessages(
              generateTextMessageData("", "bot", this.state.isfontSize)
            );
          }
        );
      }
    }
    if (languages.fontSize == "medium") {
      if (this.state.isfontSize !== "medium") {
        this.setState(
          {
            isfontSize: "medium",
          },
          () => {
            this.setMessages(
              generateTextMessageData("", "bot", this.state.isfontSize)
            );
          }
        );
      }
    }
    if (languages.fontSize == "large") {
      if (this.state.isfontSize !== "large") {
        this.setState(
          {
            isfontSize: "large",
          },
          () => {
            this.setMessages(
              generateTextMessageData("", "bot", this.state.isfontSize)
            );
          }
        );
      }
    }
    this.setState({ ConfirmUserPreference: true });
  };
  handleLanguageChange = (language) => {
    this.setState({ selectedLanguage: language });
    console.log("here ");

    // Do whatever you need to do with the selected language here
  };
  // handleMessage = (event) => {
  //   const messageData = event.data;
  //   if (messageData.type === 'reload') {
  //     window.location.reload();
  //   }
  // };
  toggleScrollFunctionality = () => {
    this.setState(
      (prevState) => ({
        isScrollToTop: !prevState.isScrollToTop,
      }),
      () => {
        // Use the callback to ensure that the state update has finished.
        if (this.state.isScrollToTop) {
          this.scrollToTop();
        } else {
          this.scrollToBottom();
        }
      }
    );
  };

  scrollToBottom = () => {
    if (this.chatBoxRef) {
      this.chatBoxRef.scrollTop = this.chatBoxRef.scrollHeight;
    }
  };

  scrollToTop = () => {
    const chatBoxRef = this.refs.chat_box_ref;
    chatBoxRef.scrollTop = 0;
  };

  setGuidedMessages(message) {
    this.setState({ guidedMenuMessages: message });
  }

  setMessages(message, typingBubble = false) {
    if (!typingBubble) {
      this.setState({
        messages: [...this.state.messages, message],
      });
    } else {
      this.setState((ps, p) => {
        return { messages: [...ps.messages, message] };
      });
    }
  }

  // Sample Floating Message
  setMenuMessages(message, typingBubble = false) {
    if (!typingBubble) {
      this.setState({
        menuMessages: [...this.state.menuMessages, message],
      });
    } else {
      this.setState((ps, p) => {
        return { menuMessages: [...ps.menuMessages, message] };
      });
    }
  }
  //welcomebot message
  setBotGreeting = (lang) => {
    this.setMessages(generateWelcomeMessage());
  };
  //Sample Ad Messages
  setAdsMessages(adImage) {
    // message
    this.setState({
      adsDataList: [...this.state.adsDataList, adImage],
    });
  }

  renderTempMessage(messages) {
    return (
      <Message
        typingBubble={true}
        // key={i}
        isTyping={this.props.isTyping}
        from="bot@hermes"
        speaks="bot"
        previousQuery={this.state.previousQuery}
      />
    );
  }

  setTempMessages() {
    let tempMessage = generateBotTypingData();
    this.setState({
      tempMessages: [...this.state.tempMessages, tempMessage],
    });
  }

  removeTempMessages() {
    this.setState({
      tempMessages: [],
    });
  }

  setRateModalActive = (value) => {
    if (value) {
      return new Promise((resolve, reject) => {
        this.setState(
          {
            workflow_id: 1,
          },
          function () {
            this.setState({ isRateModalActive: true }, () => {
              resolve();
            });
          }.bind(this)
        );
      });
    }
  };

  setWorkflowSelected(value) {
    if (value) {
      return new Promise((resolve, reject) => {
        this.setState(
          {
            workflow_id: 1,
          },
          function () {
            this.setState({ workflow_name: value }, () => {
              resolve();
            });
          }.bind(this)
        );
      });
    }
  }

  /**
   * value => user_data
   */
  setWorkflowState(value) {
    // this.setState({ isWorkflowEnabled: true });
    // console.log("setWorkflowState is called");
    if (value) {
      // console.log("setWorkflowState_value: ", value);
      return new Promise((resolve, reject) => {
        this.setState(
          {
            /**
             * workflow_id = target_id,
             * should be dynamic later
             */
            workflow_id: 1,
          },
          function () {
            this.setState({ isWorkflowEnabled: true }, () => {
              resolve();
            });
          }.bind(this)
        );
      });
    } else {
      return new Promise((resolve, reject) => {
        this.setState(
          {
            workflow_id: null,
          },
          () => {
            this.setState(
              {
                isWorkflowEnabled: false,
              },
              function () {
                resolve();
              }
            );
          }
        );
      });
    }
  }

  setWorkflowActivityId(value) {
    return new Promise((resolve, reject) => {
      this.setState(
        {
          workflow_id: 123,
        },
        function () {
          this.setState({ workflow_activity_id: value }, () => {
            resolve();
          });
        }.bind(this)
      );
    });
  }

  setUserSelectYesorNo() {
    this.setState({
      customMessages: [
        generateActionMessageData([
          {
            value: "YES",
            onClick: () => {
              this.onUserSelectYesorNo("YES");
              this.setState({ customMessages: [] });
              
            },
          },
          {
            value: "NO",
            onClick: () => {
              //end the workflow
              this.onUserSelectYesorNo("NO");
              this.setWorkflowState(false);
              this.setChatBOTFooterState(false);
              this.setState({ customMessages: [] });
              let finalStepMessage = `Thank you for using Adya 😃! Is there anything else I can assist you with?`;
              this.setMessages(generateTextMessageData(finalStepMessage));
            },
          },
        ]),
      ],
    });
    this.setState({ chatBOTFooterDisable: true });
  }
  setWorkFlowExitYesorNo(id, name, target,url) {
    console.log(id, name, target,url);
    this.setState({
      customMessages: [
        generateActionExitMessageData([
          {
            value: "YES",
            onClick: () => {
              this.onUserSelectYesorNo("NO");
              this.setWorkflowState(false);
              this.setChatBOTFooterState(false);
              this.setState({ customMessages: []});
              // this.setState({ customMessages: [], workflowCustomMessages: [] });
              // this.setState({onWorkflowChange:true})

              // let finalStepMessage =
              //   `Thank you for using Adya 😃! Is there anything else I can assist you with?`
              // this.setMessages(generateTextMessageData(finalStepMessage));
              // this.onClickTriggerWorkflow()
              // if(flag=="onclicktriger"){
              //   this.onClickTriggerWorkflow(flag)

              // }
              if(this.state.onWorkflowChange=="quick"){
                window.open(url, "_blank");
                return

              }
              if (this.state.onWorkflowChange) {
                let workflow_activity_id = uuid();
                let channel = "ADYA_CHATBOT";

                this.setWorkflowActivityId(workflow_activity_id);
                this.setWorkflowSelected(name);

                /**
                 * workflowEnabled State => True
                 * workflow_status => workflow state boolean value  */
                let workflow_status = this.setWorkflowState(name);
                this.setMessages(generateTextMessageData(name, "me"));

                let workflow_start_timestamp = `${new Date().toLocaleString(
                  "en-GB",
                  {
                    hour12: true,
                  }
                )}`;
                let reqBodyforWorkflow =
                  generate_triggerWorkflow_response_param(
                    id,
                    name,
                    target,
                    channel,
                    this.props.sesstionDetails.session_id,
                    workflow_activity_id,
                    workflow_start_timestamp,
                    this.state.selectedLanguage || "en"
                  );
                triggerWorkflow({
                  payload: reqBodyforWorkflow,
                });
              }
              if(this.state.onWorkflowChange==false){
                
                  //later store in redux for any Activity
                  //activity Status
                  this.setUserAcitivtyStatus();
                  this.setMessages(generateTextMessageData(name, "me"));
                  let reqBodyforGuidedMenu = generate_guidedMenu_response_param(
                    id,
                    name,
                    target,
                    this.props.botType.language,
                    this.props.sesstionDetails.session_id
                  );
                  sendQuery({
                    to: "menu",
                    payload: reqBodyforGuidedMenu,
                  });
                
              }
            },
          },
          {
            value: "NO",
            onClick: () => {
              //end the workflow
              // this.onUserSelectYesorNo("NO");
              // this.setWorkflowState(false);
              // this.setChatBOTFooterState(false);
              this.setState({ customMessages: [] });
              // let finalStepMessage =
              //   "Thank You for Using Adya 😃! Can I Help You With Something Else?";
              // this.setMessages(generateTextMessageData(finalStepMessage));
             
              if(this.state.workflow_name=="CIF Blocking"){
                this.setCIFWorkflowYesorNo()
              }
            },
          },
        ]),
      ],
    });
    this.setState({ chatBOTFooterDisable: true });
  }
  setCIFWorkflowYesorNo() {
    this.setState({
      customMessages: [
        generateActionCIFMessageData([
          {
            value: "YES",
            onClick: () => {
              this.onSendWorkflowData("cifquery");
              this.onUserSelectYesorNo("NO");
              this.setWorkflowState(false);
              this.setChatBOTFooterState(false);
              this.setState({ customMessages: [] });
              // this.setState({ customMessages: [] });
            },
          },
          {
            value: "NO",
            onClick: () => {
              //end the workflow
              this.onUserSelectYesorNo("NO");
              this.setWorkflowState(false);
              this.setChatBOTFooterState(false);
              this.setState({ customMessages: [] });
              let finalStepMessage = `Thank you for using Adya 😃! Is there anything else I can assist you with?`;
              this.setMessages(generateTextMessageData(finalStepMessage));
            },
          },
        ]),
      ],
    });
    this.setState({ chatBOTFooterDisable: true });
  }

  setUserServiceChanger() {
    this.setState({
      customMessages: [
        generateActionMessageData([
          {
            value: "YES",
            onClick: () => {
              // this.onUserSelectYesorNo("YES");
              this.setServiceChanger("en");
              this.setState({ customMessages: [] });
            },
          },
          {
            value: "NO",
            onClick: () => {},
          },
        ]),
      ],
    });
  }
  setChatBOTFooterState(value) {
    if (value) {
      return new Promise((resolve, reject) => {
        this.setState(
          function () {
            this.setState({ chatBOTFooterDisable: true }, () => {
              resolve();
            });
          }.bind(this)
        );
      });
    } else {
      return new Promise((resolve, reject) => {
        this.setState(
          {
            workflow_id: null,
          },
          () => {
            this.setState(
              {
                chatBOTFooterDisable: false,
              },
              function () {
                resolve();
              }
            );
          }
        );
      });
    }
  }

  // setUserInput(e) {
  //   let value = e.target.value;
  //   value = value.trimStart();
  //   this.setState({ inputValue: value });
  //   // this.setState({ userInput: e.target.value }, function () {});
  // }

  // setUserInput = (event) => {
  //   let value = event.target.value;
  //   value = value.trimStart();
  //   this.setState({ inputValue: value });

  //   if (value.length > 0 && value !== " " ) {

  //     const staticSuggestions = [
  //       "What is ADYA",
  //       "What is IB",
  //       "What is IND OASIS",
  //       "What is DIGI",
  //       "Personal Loan"
  //   ];

  //   const suggestionsToFilter = staticSuggestions;

  //   const filteredSuggestions = suggestionsToFilter.filter((suggestion) =>
  //     suggestion.toLowerCase().includes(value.toLowerCase())
  //   );

  //     // this.setState({userActivity: true})

  //     this.setState({ suggestions: filteredSuggestions });
  //     // console.log(filteredSuggestions);
  //   } else {
  //     this.setState({ suggestions: [] });
  //   }
  // };

  setUserInput = (event) => {
    let value = event.target.value;
    value = value.replace(/[^a-zA-Z0-9 .,%!?;/:'"-]/g, ""); // Remove unwanted characters

    // Limit input length to 500 characters
    const maxLength = 500;
    if (value.length > maxLength) {
      value = value.substring(0, maxLength);
    }
    const staticSuggestions = [
      "What is ADYA",
      "What is IB",
      "What is IND OASIS",
      "What is DIGI",
      "Personal Loan",
    ];
    const filteredSuggestions = staticSuggestions.filter((suggestion) =>
      suggestion.toLowerCase().startsWith(value.toLowerCase())
    );

    this.setState({
      inputValue: value,
      suggestions: filteredSuggestions,
      selectedSuggestionIndex: -1,
    });
  };
  handleSelect = (selectedSuggestion) => {
    console.log("_________________________________");
    this.refs.botInput.focus();
    this.setState({
      inputValue: selectedSuggestion,
      suggestions: [],
      selectedSuggestionIndex: -1,
    });
  };

  // async add_user_query_to_bot(query) {
  //   let says = {
  //     speaks: "me",
  //     msg: {
  //       text: {
  //         text: query,
  //       },
  //     },
  //   };

  //   this.setState({ messages: [...this.state.messages, says] });

  //   this.props.bot_message_added();
  //   this.props.update_botTyping_to_true();
  // }

  getUserQueryNlp(text) {
    return new Promise((resolve, reject) => {
      this.setState(
        { adya_query: text },
        function () {
          this.setState({ userQueryNlp: text }, () => {
            resolve();
          });
        }.bind(this)
      );
    });
  }

  getFromLastGuidedMenu(text) {
    if (this.state.guidedMenuMessages != null) {
      let guidedMenuMessage = this.state.guidedMenuMessages;
      let guidedMenuButtonsObject =
        guidedMenuMessage.msg.data.BODY.details.data.buttons;
      let selectedButton = guidedMenuButtonsObject.filter((button) => {
        if (this.props.botType.language == "en")
          return button.name.toLowerCase() == text.toLowerCase();
        return button.name == text;
      });

      if (selectedButton.length > 0) {
        if (selectedButton[0].target == "workflow") {
          /**
           * 1. set workflow state to be true
           * 2. call trigger workflow event emitter to start the workflow
           */
          // console.log("selected button target is workflow");
          // this.onClickTriggerWorkflow(selectedButton[0].targetId, text, selectedButton[0].target);
          let workflow_status = this.setWorkflowState(text);
          // console.log("workflow_status: ", workflow_status);
          let reqBodyforWorkflow = generate_triggerWorkflow_response_param(
            selectedButton[0].targetId,
            text,
            selectedButton[0].target
          );
          triggerWorkflow({
            payload: reqBodyforWorkflow,
            isWorkflowEnabled: workflow_status,
          });
          return true;
        } else {
          let reqBodyforGuidedMenu = generate_guidedMenu_response_param(
            selectedButton[0].targetId,
            text,
            selectedButton[0].target,
            this.props.botType.language
          );
          sendQuery({
            to: "menu",
            payload: reqBodyforGuidedMenu,
          });
          return true;
        }
      }
      return false;
    } else {
      return false;
    }
  }

  async df_text_query(text) {
    debugger;
    const orignalText = text;
    console.log("this is langauge :", this.state.selectedLanguage);

    this.setState({ loadingDots: true, tempImpMsg: "" });
    // text = '*'.repeat(text.length);
    // text = (istrue ? text.doit : text)
    // console.log("state type: ", this.state.chatBOTFooterDisable);

    /**
     * 1. state to be created for isWorkflowUserInputSensitive => for workflow
     * 2. if true => text = '*'.repeat(text.length);
     * 3. if false => text = text;
     */
    this.scrollToBottom();
    //Delete any custom messages if any
    if (this.state.customMessages.length > 0) {
      this.setState({ customMessages: [] });
    }

    // addTranscript(text);
    //Convert any otger language to english (if text exits)
    if (text !== "") {
      if (this.props.botType.language !== "en") {
        this.setMessages(generateTextMessageData(text, "me"), true);
        try {
          // console.log("Need to enable later");
          // text = await getTranslation(text);
        } catch (err) {
          // console.warn(err);
        }
      } else {
        this.setMessages(generateTextMessageData(text, "me"), true);
      }
    }

    // Checking if Workflow is Enabled
    if (this.state.isWorkflowEnabled == true) {
      /** 1. Call function that sends the text data to workflow socket
       *  2. to => workflow
       */
      // console.log("WORKFLOW ENABLED: ", this.state.isWorkflowEnabled);
      // console.log("text inside workflow", text);
      /**
       * function calling which sends user input to backend
       * => event emit => workflow_data
       */

      this.onSendWorkflowData(orignalText, this.state.isWorkflowEnabled);
      // let text1 = '*'.repeat(text.length);
      text = "*".repeat(text.length);
      // console.log("encrpyted text: ", text);
    } else {
      if (this.getFromLastGuidedMenu(orignalText)) return;
      this.setTempMessages();
      this.setState({ previousQuery: text });
      let text_lc = text.toLowerCase();
      if (
        text == "connect to agent" ||
        text == "connect me" ||
        text == "@connect"
      ) {
        this.props.set_talk_to_what("agent");
      } else {
        let message_uuid = uuid();
        this.props.update_botTyping_to_true();
        if (text == "") {
          this.setMessages(
            generateTextMessageData("Ohoo! Please type someting")
          );
          this.props.update_botTyping_to_false();
        } else {
          // this.createTextMessage(text, "me");

          this.props.bot_message_added();
          //Disable input box
          this.props.update_botTyping_to_true();

          /**
           *  Adya nlp
           */
          let query_id = uuid();
          let channel = "ADYA_CHATBOT";
          //hardcoded for now! Once integrated with API, user_lang to be dynamic
          let user_language = "english";
          let query_request_timestamp = `${new Date().toLocaleString("en-GB", {
            hour12: true,
          })}`;

          // let query_request_timestamp = `${new Date()}`;

          /**
           * Configuration for MultiGPU Postgres => mdy
           */
          // let workflow_start_timestamp = `${new Date().toLocaleString("en-US", {
          //   hour12: true,
          // })}`;

          this.getUserQueryNlp(text);

          let reqBody = generate_adya_nlp_response_param(
            user_language,
            text,
            query_id,
            this.props.sesstionDetails.session_id,
            channel,
            query_request_timestamp
          );
          sendQuery({ to: "adya_nlp", payload: reqBody });
          this.props.set_user_query_nlp(text);
          this.props.update_botTyping_to_false();
        }
      }
      this.removeTempMessages();
    }
  }

  addTypingBubble(data) {
    this.setState({ messages: [...this.state.messages, data] });
  }

  removeTypingBubble() {
    this.state.messages.pop();
  }

  generateSpeech(text, forceTalk = false) {
    //configure ttsoption based on language selected in redux

    if (this.props.botType.format == "voice" || forceTalk == true) {
      window.ttsEngine.getInstance().speak({
        text: text,
        audioUrl: "",
        ttsOptions:
          this.props.botType.language == "en"
            ? {
                language: "en-IN",
                voice: "Google UK English Male",
              }
            : {
                language: "hi-IN",
                voice: "Google हिन्दी",
              },
        onEnd: () => {
          // console.log("Completed TTS");
        },
      });
    }
  }

  async createMessage(messageData, INTENT_FLAG, QUERY, AGR) {
  
    // this.setUserAcitivtyStatus();
    //Adding a transcript record
    // if (messageData["BODYTYPE"] === "STRING") {
    //   addTranscript(messageData["BODY"], "bot");
    // } else {
    //   addTranscript("", "bot", messageData.BODYTYPE);
    // }
    // if(this.state.selectedLanguage == "en"){
    //   this.setMessages(generateTextMessageData(messageData.BODY.data));
    // }
    // else if (this.state.selectedLanguage == "hn"){
    //   this.setMessages(generateTextMessageData("मोबाइल नंबर पंजीकृत नहीं है। कृपया पंजीकृत मोबाइल नंबर का उल्लेख करें।"));
    // }
    // else if (this.state.selectedLanguage == "od"){
    //   this.setMessages(generateTextMessageData("ମୋବାଇଲ୍ ନମ୍ବର ପଞ୍ଜୀକୃତ ନୁହେଁ। ଦୟାକରି ପଞ୍ଜୀକୃତ ମୋବାଇଲ୍ ନମ୍ବର ଉଲ୍ଲେଖ କରନ୍ତୁ।"));
    // }
    console.log(
      "---------------------------------",
      this.state.selectedLanguage
    );
    console.log("000000000000000000000", messageData);
    if (messageData.from == "agr") {
      if (messageData.data.MESSAGE.RESULT[0].BODY.end_connection !== true) {
        if (messageData.data.MESSAGE.RESULT[0].BODY.prompt == "text_message") {
          this.setMessages(
            generateTextMessageData(
              messageData.data.MESSAGE.RESULT[0].BODY.message
            )
          );
          if (this.state.chatBOTFooterDisable == true) {
            this.setState({ chatBOTFooterDisable: false });
          }
          return;
        } else if (
          messageData.data.MESSAGE.RESULT[0].BODY.prompt == "option_selection"
        ) {
          this.setMessages(
            generateTextMessageData(
              messageData.data.MESSAGE.RESULT[0].BODY.message
            )
          );
          this.setMessages(generateAgrflowData(messageData));
          return;
        } else if (
          messageData.data.MESSAGE.RESULT[0].BODY.prompt == "date_range"
        ) {
          this.setMessages(
            generateTextMessageData(
              messageData.data.MESSAGE.RESULT[0].BODY.message
            )
          );
          this.setMessages(generateAgrflowDataDateRange(messageData));
          this.setState({ chatBOTFooterDisable: true });
          return;
        } else if (
          messageData.data.MESSAGE.RESULT[0].BODY.prompt == "date_picker"
        ) {
          this.setMessages(
            generateTextMessageData(
              messageData.data.MESSAGE.RESULT[0].BODY.message
            )
          );

          this.setMessages(generateAgrflowDataDatepicker(messageData));
          return;
        }
      }
      if (messageData.data.MESSAGE.RESULT[0].BODY.prompt == "link") {
        this.setMessages(generateAgrCardMessageData(messageData));
        return;
      } else if (
        messageData.data.MESSAGE.RESULT[0].BODY.end_connection == true
      ) {
        if (messageData.data.MESSAGE.RESULT[0].BODY.prompt == "link") {
          this.setMessages(generateAgrCardMessageData(messageData));
          return;
        }
        this.setMessages(
          generateTextMessageData(
            messageData.data.MESSAGE.RESULT[0].BODY.message
          )
        );
        if (this.state.selectedLanguage == "en") {
          this.setMessages(
            generateTextMessageData(
              "Thank you for reaching out, we have disconnected"
            )
          );
        } else if (this.state.selectedLanguage == "hn") {
          this.setMessages(
            generateTextMessageData(
              "संपर्क करने के लिए धन्यवाद, हमने संपर्क तोड़ दिया है"
            )
          );
        } else if (this.state.selectedLanguage == "od") {
          this.setMessages(
            generateTextMessageData(
              "ପହଞ୍ଚିବା ପାଇଁ ଧନ୍ୟବାଦ, ଆମେ ସଂଯୋଗ ବିଚ୍ଛିନ୍ନ କରିଛୁ |"
            )
          );
        }
        this.setWorkflowState(false);
      }
    }
    try {
      if (messageData && messageData["BODYTYPE"] === "STRING") {
        //Adding a message if exist
        if (messageData.BODY && messageData.BODY !== "") {
          if (this.props.botType.language === "en") {
            this.generateSpeech(messageData.BODY);
          }
          // this.createTextMessage(messageData.BODY);
          if (this.props.botType.language !== "en") {
            messageData.BODY = await getTranslation(
              messageData.BODY,
              this.props.botType.language
            );
            this.generateSpeech(messageData.BODY);
            this.setMessages(generateTextMessageData(messageData.BODY));
          } else this.setMessages(generateTextMessageData(messageData.BODY));
        }
      } else if (
        messageData &&
        messageData["BODYTYPE"] === "MENU" &&
        INTENT_FLAG === "menu"
      ) {
        const guidedMenuMessageData =
          generateGuidedMenuMessageData(messageData);
        this.setGuidedMessages(guidedMenuMessageData);
        this.setMessages(guidedMenuMessageData);
        this.scrollToBottom();
      } else if (
        messageData &&
        messageData["BODYTYPE"] === "QUICKMENU" &&
        INTENT_FLAG === "quickmenu"
      ) {
        this.setMessages(generateQuickMenuData(messageData));
        this.setFloatingWelcomeMenu("en");
      } else if (
        messageData &&
        messageData["BODYTYPE"] === "HEROCARD" &&
        INTENT_FLAG === "herocard"
      ) {
        this.setMessages(generateGuidedHeroCardMessageData(messageData));

        this.scrollToBottom();
      } else if (
        messageData &&
        messageData["BODYTYPE"] === "FAQMENU" &&
        INTENT_FLAG === "faqmenu"
      ) {
        // console.log("FAQMENU Data: ", messageData);
        this.setMessages(generateMenuFaqData(messageData));
        this.scrollToBottom();
      } else if (
        messageData &&
        messageData["BODYTYPE"] === "WORKFLOW" &&
        INTENT_FLAG === "workflow"
      ) {
        if (AGR?.data?.MESSAGE?.AGR_result !== undefined) {
          if (
            AGR.data.MESSAGE.AGR_result.message == "agr_api" &&
            AGR.data.MESSAGE.AGR_result.value.Agr_response_data.prompt ==
              "text_message"
          ) {
            this.setMessages(
              generateTextMessageData(
                AGR.data.MESSAGE.AGR_result.value.Agr_response_data.message
              )
            );
            return;
          }
        }
        if (messageData?.esFailure == true) {
          this.setMessages(generateTextMessageData(messageData.BODY));
          return;
        }
        if (messageData?.workflow_flag == "td_enquiry") {
          console.log("67879879", messageData);
          this.setMessages(generateTermDepositEnquiry(messageData));
          this.setUserSelectYesorNo();
         
          return;

        }
        if (messageData?.workflow_flag == "scp_success") {
          console.log("67879879", messageData);
          this.setMessages(generateTextMessageData(messageData.BODY.Response,"bot"));
          this.setUserSelectYesorNo();
         
          return;

        }
        
        if (messageData?.workflow_flag == "scp_error") {
          console.log("67879879", messageData);
          this.setMessages(generateTextMessageData(messageData.BODY.Response,"bot"));
          this.setUserSelectYesorNo();
         
          return;

        }
        if (messageData?.BODY.type == "Stop_Cheque_Payment_Form") {
         
          console.log("scp_form", messageData);
          this.setMessages(generateSCPform(messageData));
          // this.setUserSelectYesorNo();
          return;

        }
        if (messageData?.workflow_flag == "td_enquiry_error" ) {
          console.log("error message",messageData.BODY.ErrorMessage)
          this.setMessages(generateTextMessageData(messageData.BODY.ErrorMessage||"Invalid TD Account Enquiry Option"))
          this.setUserSelectYesorNo();
          return
        }
      
     
        // if(messageData.data.MESSAGE.RESULT[0].Msg=="Cif_already_blocked"){
        //     this.setMessages.generateTextMessageData("Cif has already blocked")
        // }
        if (messageData?.esFailure == false) {
          this.setMessages(
            generateTextMessageData(
              "The Email Statement has been sent to your registered email address."
            )
          );

          this.setUserSelectYesorNo();
          return;
        }
        if (messageData?.BODY?.CIFBlocking_Response) {
          if (messageData.BODY.CIFBlocking_Response.Body.Payload.Status) {
            this.setMessages(generateTextMessageData("Cif has been blocked"));
          }
          let finalStepMessage = `Thank you for using Adya 😃! Is there anything else I can assist you with?`;
          this.setMessages(generateTextMessageData(finalStepMessage));

          this.setState({ customMessages: [] });
          return;
        }
        if (messageData.BODY.AccountEnquiryDetails_Response) {
          console.log(messageData.BODY);
          this.setMessages(generateViewAccountDetails(messageData.BODY));
          this.setState({ chatBOTFooterDisable: false });
          this.setUserSelectYesorNo();
          return;
        }
        if (
          (messageData.Msg =
            "Cif_already_blocked" && messageData.workflow == "cif_blocked")
        ) {
          // console.log("///")
          this.setMessages(generateTextMessageData("Transactions already blocked for the CIF linked to your mobile number"));
          this.setWorkflowState(false);
          this.setChatBOTFooterState(false);

          let finalStepMessage = `Thank you for using Adya 😃! Is there anything else I can assist you with?`;
          this.setMessages(generateTextMessageData(finalStepMessage));
          this.setChatBOTFooterState(false);
          return;
        }

        if (
          (messageData.Msg = "Vad_error" && messageData.workflow == "vad_error")
        ) {
          // console.log("///")
          this.setMessages(generateTextMessageData("Invalid Account Enquiry"));
          this.setUserSelectYesorNo();
          // this.setWorkflowState(false);
          // this.setChatBOTFooterState(false);

          // let finalStepMessage =
          //   `Thank you for using Adya 😃! Is there anything else I can assist you with?`
          // this.setMessages(generateTextMessageData(finalStepMessage));
          // this.setChatBOTFooterState(false)
          return;
        }
        if (messageData.BODY.type == "text") {
          if (
            messageData?.BODY?.data ==
            "Please enter the OTP received on your registered mobile number."
          ) {
            this.setMessages(generateOtpValidation());
            this.setState({ chatBOTFooterDisable: true });
            return;
          }
          if (
            messageData?.BODY?.data ==
            "OTP is invalid. Kindly enter the OTP received on your registered mobile number."
          ) {
            this.setMessages(generateTextMessageData(messageData.BODY.data));
            // this.setState({
            //   workflowCustomMessages:[

            //     this.setMessages(generateOtpValidation())
            //   ]
            // })
            this.setMessages(generateOtpValidation());

            this.setState({ chatBOTFooterDisable: true });
            return;
          }

          // else{ 'Invalid OTP. Kindly Send The OTP Sent To Your Registered Mobile Number'Mobile Number Not Registered. Kindly mention the Registered Mobile Number.'
          //   this.setMessages(generateTextMessageData(messageData.BODY.data));
          //   return Please Enter Your Registered 10 Digit Mobile Number.
          // }
          if (
            messageData?.BODY?.data ==
            "Please enter your registered 10-digit mobile number."
          ) {
            this.setMessages(generateMobileValidation(messageData));
            this.setState({ chatBOTFooterDisable: true });
            return;
          }
          if (
            messageData?.BODY?.data ==
            "Mobile Number Not Registered. Kindly mention the Registered Mobile Number. 10 Digit Mobile Number."
          ) {
            this.setMessages(generateMobileValidation(messageData));
            this.setState({ chatBOTFooterDisable: true });
            return;
          }
          this.setMessages(generateTextMessageData(messageData));
        }
        // console.log(messageData);
        /** new setMessage for workflow can be created later */
        if (messageData.BODY.type == "account_list") {
          // this.setMessages(generateTextMessageData("Please select you account and hit submit, then enter your query down below"))
          // if (
          //   this.state.selectedLanguage == "en" &&
          //   this.state.workflow_name == "Excess Bank Charges"
          // ) {
          //   // this.setMessages(
          //   //   generateTextMessageData(
          //   //     "Please select you account and hit submit, then enter your query down below"
          //   //   )
          //   // );
          // } else if (this.state.selectedLanguage == "hn") {
          //   this.setMessages(
          //     generateTextMessageData(
          //       "कृपया अपना खाता चुनें और सबमिट दबाएँ, फिर नीचे अपनी क्वेरी दर्ज करें"
          //     )
          //   );
          // } else if (this.state.selectedLanguage == "od") {
          //   this.setMessages(
          //     generateTextMessageData(
          //       "ଦୟାକରି ତୁମକୁ ଖାତା ବାଛ ଏବଂ ଦାଖଲ ଦବାନ୍ତୁ, ତାପରେ ନିମ୍ନରେ ତୁମର ଜିଜ୍ଞାସା ପ୍ରବେଶ କର |"
          //     )
          //   );
          // }
        }

        if (messageData.BODY.type == "CIFQUERY") {
          this.setMessages({ customMessages: [] });
          this.setMessages(generateWorkflowData(messageData));

          this.setCIFWorkflowYesorNo();
          //       let finalStepMessage =
          //   "Thank You for Using Adya 😃! Can I Help You With Something Else?";
          // this.setMessages(generateTextMessageData(finalStepMessage));
          // this.setState({chatBOTFooterDisable:true})
          return;
        }
        if (messageData.BODY.type == "date_range") {
          this.setMessages(
            generateTextMessageData(
              "Please select the statement from date and to date"
            )
          );
          this.setState({ chatBOTFooterDisable: true });
          this.setMessages(generatesteflowData(messageData));
        }
        this.setState({ chatBOTFooterDisable: true });
        this.setMessages(generateWorkflowData(messageData));
        this.setState({ chatBOTFooterDisable: true });

        if (messageData.BODY.type == "account_list") {
          if (this.state.isWorkflowEnabled == false) {
            this.setState({ isWorkflowEnabled: true });
          }
        }
        /**
         * 1. Function needs to be created to initiate callback for state disable being true.
         */
        if (messageData.BODY.isUserChatBOTFooterDisabled === true) {
          /**
           * 1. State disable => true
           */
          //chatbot_footerState
          this.setChatBOTFooterState(true);
        } else {
          this.setChatBOTFooterState(false);
          this.setState({ chatBOTFooterDisable: true });
        }

        /**
         * 1. To Check: isWorkflowFinalStep => true || False
         *    if Y => disable active workflow step to end the workflow session
         *    if N => no seperate action => keep the workflow going
         */
        if (messageData["ISWORKFLOWFINALSTEP"] === true) {
          /**
           * UPDATE 1901
           * 1. Check Yes or No for Another Account
           *  => If Y => Workflow State is Enabled & Account List is Fetched
           *  => If N => Wokflow State is Disabled
           */
          // disable active workflow to inactive
          // let user_select_status = this.setUserSelectYesorNo();
          this.setState({ chatBOTFooterDisable: true });
          this.setUserSelectYesorNo();
          // this.setUserServiceChanger()
        }
        this.scrollToBottom();
      } else if (
        messageData &&
        messageData["BODYTYPE"] === "adya_nlp" &&
        INTENT_FLAG === "adya_nlp"
      ) {
        // this.setState({chatBOTFooterDisable:false})
        this.setUserAcitivtyStatus();
        // console.log("messageData Adya Nlp: ", messageData);
        // console.log("Nlp query: ", this.state.userQueryNlp);
        // this.setMessages(
        //   generate_nlp_qa_MessageData(messageData, this.state.userQueryNlp)
        // );

        //setMessages according to Source
        if (messageData.BODY.source == "smalltalks") {
          this.setMessages(generateTextMessageData(messageData.BODY.result));
        } else if (messageData.BODY.source == "smartmenu") {
          if (messageData.BODY.result.Target == "menu") {
            // console.log("messageData.BODY.result.Target: ", messageData.BODY.result.Target);
            //Call Initial Guided Menu
            let menu_id = messageData.BODY.result.Id;
            let menu_name = messageData.BODY.result.For;
            let menu_target = messageData.BODY.result.Target;
            this.onTypedMenuHandler(menu_id, menu_name, menu_target);
          } else if (messageData.BODY.result.Target === "herocard") {
            // console.log("messageData.BODY.result.Target: ", messageData.BODY.result.Target);
            //Call Initial Guided Menu
            let menu_id = messageData.BODY.result.Id;
            let menu_name = messageData.BODY.result.For;
            let menu_target = messageData.BODY.result.Target;
            this.onTypedMenuHandler(menu_id, menu_name, menu_target);
          } else if (messageData.BODY.result.Target === "workflow") {
            // console.log("messageData.BODY.result.Target: ", messageData.BODY.result.Target);
            //Triggers Workflow
            // let workflow_id = parseInt(messageData.BODY.result.Id);
            let workflow_id =
              messageData.BODY.result.Id === "123"
                ? parseInt(messageData.BODY.result.Id)
                : messageData.BODY.result.Id;
            let workflow_name = messageData.BODY.result.For;
            let workflow_target = messageData.BODY.result.Target;

            // console.log("typeof workflowid: ", typeof workflow_id);

            this.onTypedTriggerWorkflow(
              workflow_id,
              workflow_name,
              workflow_target
            );
          }
        } else if (messageData.BODY.source === "None") {
          this.setMessages(generateTextMessageData(messageData.BODY.result));
        } else if (messageData.BODY.source == "websitesearch") {
          this.setMessages(
            generate_nlp_qa_MessageData(messageData, this.state.userQueryNlp)
          );
        }
      }
    } catch (e) {
      throw new Error("Something went wrong while mapping the JSON");
    }
  }

  refeshChatbot(message = "hi! Welcome again!! How can I help you") {
    this.setState({ messages: [] });
    this.props.resetLoginStatus();
    //minimize chatbot
    this.props.update_botStatus_inactive();
    let says = {
      speaks: "bot",
      msg: {
        text: {
          text: message,
        },
      },
    };
    setTimeout(
      function () {
        this.setState({ messages: [says] });
      }.bind(this),
      500
    );

    this.props.update_botTyping_to_false();
    window.location.reload(false);
  }

  getFeedback = () => {
    window.addEventListener("message", (event) => {
      if (event.data == "userpreference") {
        console.log("........ userpreference");
        // <LanguageSelector onLanguageSelect={this.handleLanguageSelect} />
        this.setState({ languageModalIsOpen: true });
      }
      if (event.data == "onConfirm") {
        console.log("Feedback");

        this.setState({ isRateModalActive: true });
      }

      if (event.data == "reload") {
        console.log("Refresh");
        this.setState({ refreshConfirmOpen: true });
        // if(refreshConfirmOpen){
        // <RefreshConfirmodal  onRefersh={this.onRefersh} ></RefreshConfirmodal>
        // }
        // this.setState({open:true})
        // this.reloadChatbox();
        // this.props.update_botStatus_inactive();
        // this.props.resetLoginStatus();
      }
      if (event.data == "LIGHT THEME") {
        this.setState({ isDarkMode: false });
      }
      if (event.data == "DARK THEME") {
        this.setState({ isDarkMode: true });
      }
      if (event.data == "hn") {
        this.setState({ messages: [] });
        this.setFloatingQuickMenu("hn");
        this.setFloatingWelcomeMenu("hn");
        // this.setBotGreeting();
        // this.setWelcomeAds();
      }
      if (event.data == "en") {
        this.setState({ messages: [] });
        this.setFloatingQuickMenu("en");
        this.setFloatingWelcomeMenu("en");
        // this.setWelcomeAds();
      }

      if (event.data === "small") {
        if (this.state.isfontSize !== "small") {
          this.setState(
            {
              isfontSize: "small",
              isfontState: true,
            },
            () => {
              console.log(this.state.isfontSize);
              this.setMessages(
                generateTextMessageData("", "bot", this.state.isfontSize)
              );
              // this.setMessages(generateGuidedMenuMessageData("","bot1","",this.state.isfontSize));
            }
          );
        }
      }
      if (event.data == "medium") {
        console.log("medium.......... from evrnt");
        if (this.state.isfontSize !== "medium") {
          this.setState(
            {
              isfontSize: "medium",
              isfontState: true,
            },
            () => {
              this.setMessages(
                generateTextMessageData("", "bot", this.state.isfontSize)
              );
              this.setMessages(
                generateGuidedMenuMessageData(
                  "",
                  "bot1",
                  "",
                  this.state.isfontSize
                )
              );
            }
          );
        }
        // console.log("medium");
        // this.setState({ isfontSize:'medium'});

        // console.log(this.state.isfontSize)

        // this.setState({isfontState:true})
        // this.setMessages(generateTextMessageData("","bot",this.state.isfontSize))
      }
      if (event.data == "large") {
        // console.log("large");
        // this.setState({ isfontSize: "large"});
        // this.setState({isfontState:false})
        // this.setMessages(generateTextMessageData("","bot",this.state.isfontSize))
        if (this.state.isfontSize !== "large") {
          this.setState(
            {
              isfontSize: "large",
              isfontState: true,
            },
            () => {
              this.setMessages(
                generateTextMessageData("", "bot", this.state.isfontSize)
              );
            }
          );
        }
      }
    });
    // this.setFloatingQuickMenu("en");
    // this.setFloatingWelcomeMenu("en");
  };

  setUserVisit = () => {
    // send for User Visit
    let user_session_id = this.props.sesstionDetails.session_id;
    this.state.user_activity_status = "no";
    // let reqBody
    let userVisitData = {
      SESSION_ID: this.props.sesstionDetails.session_id,
      USER_ACTIVITY_STATUS: this.state.user_activity_status,
    };
    sendUserVisit(userVisitData);
  };

  setUserAcitivtyStatus = () => {
    // console.log(
    //   "this.state.user_activity_status: ",
    //   this.state.user_activity_status
    // );
    let status = this.state.user_activity_status;

    if (status === "no") {
      this.state.user_activity_status = "yes";

      let reqBody = {
        SESSION_ID: this.props.sesstionDetails.session_id,
        USER_ACTIVITY_STATUS: this.state.user_activity_status,
      };

      // calling socket service
      sendUserActivityStatus(reqBody);
    }
  };

  // ads
  setWelcomeAds = () => {
    // ads array insertion in the adsList
    let adsImages = {
      // speaks:"advertisement",
      data: {
        adImageData: [
          {
            id: 1,
            imgSrc: ibAdLogo1,
            imgUrl: " https://www.indianbank.in/departments/indsmart/",
          },
          {
            id: 2,
            imgSrc: ibAdLogo2,
            imgUrl: "https://www.indianbank.in/departments/onlineloans/",
          },
          {
            id: 3,
            imgSrc: ibAdLogo3,
            imgUrl: " https://www.indianbank.in/departments/security/",
          },
          {
            id: 4,
            imgSrc: ibAdLogo4,
            imgUrl:
              " https://apps.indianbank.in/digitd/OpenAccount.aspx",
          },
        ],
      },
    };

    this.setAdsMessages(generateAdvertisementData(adsImages));
  };

  /**
   * setWelcomeAds(){
   *  getWelcomeAds({
   *  to: "welcome_ads"
   * })
   * }
   *

  setWelcomeMessage(language) {

    // const welcome_text = `Hello ${this.props.logInData.firstName}!<br> My name is ADYA 😃. Welcome to Indian Bank.
    // I am your virtual assistant, here to assist you with all your banking queries 24x7.`;

    /**
     * Welcome Message Selected by Client
     */
  // if (language == "en") {
  //   const welcome_text = `Hi! Welcome to Indian Bank, I am ADYA 😃, how may I assist you?`;
  //   this.setMessages(generateTextMessageData(welcome_text));
  //   return;
  // } else if (language == "hn") {
  //   const welcome_text = `नमस्ते! इंडियन बैंक में आपका स्वागत है, मैं ADYA हूं 😃, मैं आपकी कैसे सहायता कर सकता हूं?`;
  //   this.setMessages(generateTextMessageData(welcome_text));
  //   return;
  // } else if (language == "od") {
  //   const welcome_text = `ହାଏ! ଇଣ୍ଡିଆନ୍ ବ୍ୟାଙ୍କକୁ ସ୍ାଗତ, ମୁଁ ADYA 😃, ମୁଁ ଆପଣଙ୍କୁ କିପରି ସାହାଯ୍ୟ କରିପାରିବି?`;
  //   this.setMessages(generateTextMessageData(welcome_text));
  //   return;
  // } else {
  //   const welcome_text = `Hi! Welcome to Indian Bank, I am ADYA 😃, how may I assist you?`;
  //   this.setMessages(generateTextMessageData(welcome_text));
  // }
  // }

  // set Quick Menu
  setFloatingQuickMenu(language, fontSize) {
    let reqBodyforMenu = generate_Quick_Menu_response_param(
      0,
      language,
      this.props.sesstionDetails.session_id,
      fontSize
    );
    sendQuery({
      to: "quickmenu",
      payload: reqBodyforMenu,
    });
  }

  // set Quick Menu service changer
  setServiceChanger(language) {
    let reqBodyforMenu = generate_Quick_Menu_response_param(
      3,
      language,
      this.props.sesstionDetails.session_id
    );
    sendQuery({
      to: "quickmenu",
      payload: reqBodyforMenu,
      serviceChanger: true,
    });
  }
  // setFloatingWelcomeMenu
  setFloatingWelcomeMenu(lang) {
    let reqBodyforMenu = generate_floatingMenu_response_param(
      0,
      lang,
      this.props.sesstionDetails.session_id
    );
    // console.log("lang", this.props.botType.language);
    sendQuery({
      to: "menu",
      payload: reqBodyforMenu,
    });
  }

  //send upcoming features message
  onSendUpcomingMessage = (id, name, target) => {
    // this.setMessages(generateTextMessageData(name, "me"));

    if (target == "upcoming") {
      const upcoming_message = `${name} is coming soon`;

      this.setMessages(generateTextMessageData(upcoming_message));
    }
  };

  // On click Quick Menu Handler Redirecting Page
  onClickQuickMenuHandler = (url) => {
    // if(url){
    //   this.setWorkFlowExitYesorNo()
    // }
    debugger
    if (this.state.isWorkflowEnabled) {
      let msg = `<b>${this.state.workflow_name}</b> Workflow is enabled. Please enter "yes" to terminate the workflow`;
      // this.setWorkFlowExitYesorNo(this.setMessages(generateTextMessageData(msg, "bot"));
      // debugger
      // this.setWorkFlowExitYesorNo(this.setMessages({customMessages:[]}))
      // this.setWorkFlowExitYesorNo()
      // this.setMessages(generateTextMessageData(msg,"bot"))
      // this.setState({onWorkflowChange:false})
      // if(this.state.workflow_name==name){
      //   this.generateTextMessageData("You are in the same workflow please continue")
      // }
      this.setState({onWorkflowChange:"quick"})
      this.setWorkFlowExitYesorNo("","","",url);
      return
    }

    // Redirect to page on button click
    window.open(url, "_blank");
  };

  onClickGuidedMenuHandler = (id, name, target) => {
    /**
     * 1. Check if Workflow is Active
     * 2. if Y => Call a Function, throw a bot message => so and so workflow is active.
     *    Type "exit" or "close" to exit the workflow.
     * 3. if N => Resume the guidedMenu Handler.
     */
    if (this.state.isWorkflowEnabled) {
      let msg = `<b>${this.state.workflow_name}</b> Workflow is enabled. Please enter "yes" to terminate the workflow`;
      // this.setWorkFlowExitYesorNo(this.setMessages(generateTextMessageData(msg, "bot"));
      // debugger
      // this.setWorkFlowExitYesorNo(this.setMessages({customMessages:[]}))
      // this.setWorkFlowExitYesorNo()
      // this.setMessages(generateTextMessageData(msg,"bot"))
      this.setState({onWorkflowChange:false})
      if(this.state.workflow_name==name){
        this.generateTextMessageData("You are in the same workflow please continue")
      }
      this.setWorkFlowExitYesorNo(id, name, target);
    } else {
      //later store in redux for any Activity
      //activity Status
      this.setUserAcitivtyStatus();
      this.setMessages(generateTextMessageData(name, "me"));
      let reqBodyforGuidedMenu = generate_guidedMenu_response_param(
        id,
        name,
        target,
        this.props.botType.language,
        this.props.sesstionDetails.session_id
      );
      sendQuery({
        to: "menu",
        payload: reqBodyforGuidedMenu,
      });
    }
  };

  //Typed Menu
  onTypedMenuHandler = (id, name, target) => {
    if (this.state.isWorkflowEnabled) {
      let msg = `<b>${this.state.workflow_name}</b>Workflow is enabled. Please enter "yes" to terminate the workflow`;
      // this.setWorkFlowExitYesorNo(this.setMessages(generateTextMessageData(msg, "bot")))
      // this.setWorkFlowExitYesorNo(this.setMessages({customMessages:[]}))
      // this.setMessages(generateTextMessageData(msg,"bot"))
      this.setState({onWorkflowChange:false})
      this.setWorkFlowExitYesorNo();

      // this.setWorkFlowExitYesorNo()
    } else {
      //later store in redux for any Activity
      //activity Status
      // this.setUserAcitivtyStatus();
      // this.setMessages(generateTextMessageData(name, "me"));
      let reqBodyforGuidedMenu = generate_guidedMenu_response_param(
        id,
        name,
        target,
        this.props.botType.language,
        this.props.sesstionDetails.session_id
      );
      sendQuery({
        to: "menu",
        payload: reqBodyforGuidedMenu,
      });
    }
  };

  // Triggers the Workflow when the workflow is typed
  onTypedTriggerWorkflow = (id, name, target) => {
    // console.log("nlp workflow");
    if (this.state.isWorkflowEnabled) {
      let msg = `<b>${this.state.workflow_name}</b> Workflow is enabled. Please enter "yes" to terminate the workflow`;
      // this.setMessages(generateTextMessageData(msg, "bot"));
      this.setState({onWorkflowChange:true})
      if(this.state.workflow_name==name){
        this.setMessages(generateTextMessageData("You are in the same workflow please continue","bot"))
        return
      }
      this.setWorkFlowExitYesorNo(id, name, target);
      // this.setWorkFlowExitYesorNo()
    } else {
      let workflow_activity_id = uuid();
      let channel = "ADYA_CHATBOT";

      this.setWorkflowActivityId(workflow_activity_id);
      this.setWorkflowSelected(name);

      /**
       * workflowEnabled State => True
       * workflow_status => workflow state boolean value  */
      let workflow_status = this.setWorkflowState(name);
      // this.setMessages(generateTextMessageData(name, "me"));

      let workflow_start_timestamp = `${new Date().toLocaleString("en-GB", {
        hour12: true,
      })}`;

      /**
       * Configuration for MultiGPU Postgres => mdy
       */
      // let workflow_start_timestamp = `${new Date().toLocaleString("en-US", {
      //   hour12: true,
      // })}`;

      let reqBodyforWorkflow = generate_triggerWorkflow_response_param(
        id,
        name,
        target,
        channel,
        this.props.sesstionDetails.session_id,
        workflow_activity_id,
        workflow_start_timestamp
      );
      triggerWorkflow({
        payload: reqBodyforWorkflow,
      });
    }
  };

  faqMenuHandler = (id, name, target) => {
    // console.log("faqMenuHandler function entered");
    this.setUserAcitivtyStatus();

    this.setMessages(generateTextMessageData(name, "me"));
    let reqBodyforFaqMenu = generate_faqMenu_response_param(
      id,
      name,
      target,
      this.props.botType.language,
      this.props.sesstionDetails.session_id
    );

    sendQuery({
      to: "faqmenu",
      payload: reqBodyforFaqMenu,
    });
  };

  // Triggers The Workflow when the workflow guided menu is clicked
  onClickTriggerWorkflow = (id, name, target, flag) => {
    debugger;
    console.log(id, name, target, flag);
    this.setUserAcitivtyStatus();
    // console.log("nlp workflow");
    if (this.state.isWorkflowEnabled) {
      if (target == "workflowservicechanger") {
        let workflow_activity_id = uuid();
        let channel = "ADYA_CHATBOT";

        this.setWorkflowActivityId(workflow_activity_id);
        this.setWorkflowSelected(name);

        /**
         * workflowEnabled State => True
         * workflow_status => workflow state boolean value  */
        let workflow_status = this.setWorkflowState(name);
        this.setMessages(generateTextMessageData(name, "me"));

        let workflow_start_timestamp = `${new Date().toLocaleString("en-GB", {
          hour12: true,
        })}`;

        /**
         * Configuration for MultiGPU Postgres => mdy
         */
        // let workflow_start_timestamp = `${new Date().toLocaleString("en-US", {
        //   hour12: true,
        // })}`;

        let reqBodyforWorkflow = generate_triggerWorkflow_response_param(
          id,
          name,
          "workflow",
          channel,
          this.props.sesstionDetails.session_id,
          workflow_activity_id,
          workflow_start_timestamp,
          this.state.selectedLanguage || "en"
        );
        triggerWorkflow({
          payload: reqBodyforWorkflow,
        });
        return;
      }
      // if(this.state.onWorkflowChange){

      //   let workflow_activity_id = uuid();
      //   let channel = "ADYA_CHATBOT";

      //   this.setWorkflowActivityId(workflow_activity_id);
      //   this.setWorkflowSelected(name);

      //   /**
      //    * workflowEnabled State => True
      //    * workflow_status => workflow state boolean value  */
      //   let workflow_status = this.setWorkflowState(name);
      //   this.setMessages(generateTextMessageData(name, "me"));

      //   let workflow_start_timestamp = `${new Date().toLocaleString("en-GB", {
      //     hour12: true,
      //   })}`;
      //   let reqBodyforWorkflow = generate_triggerWorkflow_response_param(
      //     id,
      //     name,
      //     target,
      //     channel,
      //     this.props.sesstionDetails.session_id,
      //     workflow_activity_id,
      //     workflow_start_timestamp,
      //     this.state.selectedLanguage || "en"
      //   );
      //   triggerWorkflow({
      //     payload: reqBodyforWorkflow,
      //   });

      // }
      let msg = `<b>${this.state.workflow_name}</b> Workflow is enabled. Please enter "yes" to terminate the workflow`;
      // this.setWorkFlowExitYesorNo(this.setMessages(generateTextMessageData(msg, "bot")))
      // this.setMessages(generateTextMessageData(msg,"bot"))
      // this.setWorkFlowExitYesorNo(this.setMessages({customMessages:[]}))
      // let flag="onclicktriger"
      this.setState({ onWorkflowChange: true });
      if(this.state.workflow_name==name){
        this.setMessages(generateTextMessageData("You are in the same workflow please continue","bot"))
        return
      }
      this.setWorkFlowExitYesorNo(id, name, target);

      // this.setWorkFlowExitYesorNo()
    } else {
      let workflow_activity_id = uuid();
      let channel = "ADYA_CHATBOT";

      this.setWorkflowActivityId(workflow_activity_id);
      this.setWorkflowSelected(name);

      /**
       * workflowEnabled State => True
       * workflow_status => workflow state boolean value  */
      let workflow_status = this.setWorkflowState(name);
      this.setMessages(generateTextMessageData(name, "me"));

      let workflow_start_timestamp = `${new Date().toLocaleString("en-GB", {
        hour12: true,
      })}`;

      /**
       * Configuration for MultiGPU Postgres => mdy
       */
      // let workflow_start_timestamp = `${new Date().toLocaleString("en-US", {
      //   hour12: true,
      // })}`;

      let reqBodyforWorkflow = generate_triggerWorkflow_response_param(
        id,
        name,
        target,
        channel,
        this.props.sesstionDetails.session_id,
        workflow_activity_id,
        workflow_start_timestamp,
        this.state.selectedLanguage || "en"
      );
      triggerWorkflow({
        payload: reqBodyforWorkflow,
      });
    }
  };

  /**
   * 1. Send workflow data from user input
   *  a) Passing workflow data => mobile_number, otp, dob, account_list through one channel
   */
  onSendWorkflowData = (user_input, isworkflowEnabledStatus) => {
    // console.log("user_input: ", user_input);

    let reqBodyforWorkflowData = generate_workflow_data_response_param(
      user_input,
      this.props.sesstionDetails.session_id,
      this.state.workflow_activity_id
    );

    sendWorkflowdata({
      payload: reqBodyforWorkflowData,
      language: this.state.selectedLanguage,
    });
  };

  onSendWorkflowDatePicker = (user_input, isworkflowEnabledStatus) => {
    function formatDate(input) {
      const year = input.substring(4);
      const month = input.substring(2, 4);
      const day = input.substring(0, 2);

      // Construct the formatted date
      const formattedDate = `${day}/${month}/${year}`;

      return formattedDate;
    }

    const input = `${user_input}`;
    const formattedDate = formatDate(input);
    this.setMessages(generateTextMessageData(formattedDate, "me"), true);

    let reqBodyforWorkflowData = generate_workflow_data_response_param(
      formattedDate,
      this.props.sesstionDetails.session_id,
      this.state.workflow_activity_id,
      "Dp"
    );
    sendWorkflowdata({
      payload: reqBodyforWorkflowData,
    });
  };

  handleSendWorkflowDateRange = (user_input, isworkflowEnabledStatus) => {
    debugger
    let reqBodyforWorkflowData = generate_workflow_data_response_param(
      user_input,
      this.props.sesstionDetails.session_id,
      this.state.workflow_activity_id,
      "Dr"
    );
    sendWorkflowdata({
      payload: reqBodyforWorkflowData,
    });
  };

  onSendAgrWorkflowData = (user_input, isworkflowEnabledStatus) => {
    // console.log("user_input: ", user_input);
    let reqBodyforWorkflowData = generate_workflow_data_response_param(
      user_input,
      this.props.sesstionDetails.session_id,
      this.state.workflow_activity_id
    );
    this.setMessages(generateTextMessageData(user_input, "me"), true);

    sendWorkflowdata({
      payload: reqBodyforWorkflowData,
      type: "agr",
      language: this.state.selectedLanguage,
    });
  };

  // EventBus.on("escp_form_data",this.onSendSCPWorkFlowData)
  //This function is used to send Stop Cheque Payment Data to server.
  onSendSCPWorkFlowData(user_data){
   
    console.log(user_data)
        
  
    // this.eventEmitter.on('scp_form_submit', (data) => {
        // // ths.onSendSCPWorkFlowData(data)
        const reqBodyforWorkflowData = generate_workflow_data_response_param(
          user_data,
          this.props.sesstionDetails.session_id,
          this.state.workflow_activity_id
        );
        sendWorkflowdata({
          payload: reqBodyforWorkflowData,
          type: "stopcheckpayment",
          language: "en",
        });

        console.log("76218e777777777777y  i",sendWorkflowdata)
        return
        // console.log(data)
        
        // this.onSendWorkflowData(user_data)
        // send
      // }
    // )
    
  }
  



  // generatesteDrflowData = (startDate, endDate) => {
  //   // console.log("user_input: ", user_input);
  //   const grand_input={startDate,endDate}
  //   let reqBodyforWorkflowData = generate_workflow_data_response_param(
  //     grand_input,
  //     this.props.sesstionDetails.session_id,
  //     this.state.workflow_activity_id
  //   );
  //   this.setMessages(generateTextMessageData(`${startDate}-${endDate}`, "me"), true);
  //   sendWorkflowdata({
  //     payload: reqBodyforWorkflowData,
  //     type: "ste",
  //   });
  // };

  generatesteDrflowData = (startDate, endDate) => {
    const formattedStartDate = startDate.replace(
      /(\d{2})(\d{2})(\d{4})/,
      "$1/$2/$3"
    );
    const formattedEndDate = endDate.replace(
      /(\d{2})(\d{2})(\d{4})/,
      "$1/$2/$3"
    );
    const dateRange = `${formattedStartDate} to ${formattedEndDate}`;

    const grand_input = { startDate, endDate };
    let reqBodyforWorkflowData = generate_workflow_data_response_param(
      grand_input,
      this.props.sesstionDetails.session_id,
      this.state.workflow_activity_id
    );
    this.setMessages(generateTextMessageData(dateRange, "me"), true);
    sendWorkflowdata({
      payload: reqBodyforWorkflowData,
      type: "ste",
    });
  };

  onUserSelectYesorNo = (user_choice) => {
    let workflow_end_timestamp = `${new Date().toLocaleString("en-GB", {
      hour12: true,
    })}`;

    //MultiGPU Config for Date
    // let workflow_end_timestamp = `${new Date().toLocaleString("en-US", {
    //   hour12: true,
    // })}`;

    let reqBodyforUserSelect = generate_workflow_user_select_yesorno_param(
      user_choice,
      this.props.sesstionDetails.session_id,
      this.state.workflow_activity_id,
      workflow_end_timestamp
    );
    sendUserChoiceYesorNo({
      payload: reqBodyforUserSelect,
    });
  };

  //To Print Account List Message When There is no Account List Data
  onGetAccountListNoData(message_with_no_data) {
    // this.setMessages(
    //   generateTextMessageData(
    //     `${message_with_no_data} <br> <br> Thank You for Using Adya 😃! Workflow Terminates`
    //   )
    // );

    // Prod change after request 3003
    let message_with_no_data_found = "Please Contact Your Home Branch.";
    this.setMessages(
      generateTextMessageData(
        `${message_with_no_data_found} <br> <br> Thank You for Using Adya 😃!`
      )
    );

    this.setWorkflowState(false);
  }

  scrollToBottom = () => {
    // this.messagesEnd.current.scrollIntoView({ behavior: 'smooth' })
    // this.refs.chat_box_ref.scrollTo(0);

    if (this.refs.chat_box_ref) {
      var cc = this.refs.chat_box_ref;
      cc.scrollTop = cc.scrollHeight - cc.clientHeight;
    }
  };

  renderMessage(stateMessage) {
    if (stateMessage) {
      return stateMessage.map((message, i) => {
        return this.renderOneMessage(message, i);
      });
    } else {
      return null;
    }
  }

  renderOneMessage(message, i) {
  
    if (message.typingBubble && message.typingBubble == true) {
      return (
        <Message
          typingBubble={true}
          key={i}
          isTyping={this.props.isTyping}
          from="bot@hermes"
          speaks="bot"
          previousQuery={this.state.previousQuery}
        />
      );
    } else if (message.msg && message.msg.text && message.msg.text) {
      return (
        <React.Fragment key={i}>
          {/* {this.props.isTyping == true && <div>  <img className="bot-typing" src="image/typing.gif"></img> </div>  }
           */}
          <Message
            key={i}
            speaks={message.speaks}
            text={message.msg.text.text}
            isTyping={this.props.isTyping}
            url={message.msg.url ? message.msg.url : ""}
            listData={message.msg.listData}
            font={message.font}
            // from={message.agent ? message.agent.email : "bot@hermes"}
            from={message.agent ? message.agent.email : "adya@hermes"}
            previousQuery={this.state.previousQuery}
            fromHuman={this.state.Human_connected}
            agent={message.agent}
            fontsize={this.state.isfontSize}
            fontState={this.state.isfontState}
            language={this.state.selectedLanguage}
          />
          {/* {
            message.speaks == 'bot' &&   < MinIframe></MinIframe>
          } */}
        </React.Fragment>
      );
    } else if (message.type == "actions") {
      return (
        <Message
          speaks={message.speaks}
          actions={message.msg.actions}
          workflowQuery={this.state.workflow_name}
          previousQuery={this.state.previousQuery}
        />
      );
    } else if (message.type == "actionss") {
      return (
        <Message
          speaks={message.speaks}
          actions={message.msg.actions}
          workflowQuery={this.state.workflow_name}
          previousQuery={this.state.previousQuery}
        />
      );
    } else if (message.type == "CIF") {
    
      return (
        <Message
          speaks={message.speaks}
          actions={message.msg.actions}
          // workflowQuery={this.state.workflow_name}
          // previousQuery={this.state.previousQuery}
        />
      );
      
    } 
    // else if (message.type == "Stop_Cheque_Payment_Form") {
    //   return (
    //     <Message
    //       speaks={message.speaks}
    //       actions={message.msg.actions}
    //       // workflowQuery={this.state.workflow_name}
    //       // previousQuery={this.state.previousQuery}
    //     />
    //   );
      
    // }
    else if (message.type == "viewAccount") {
      return (
        <Message
          speaks={message.speaks}
          // actions={message.msg.actions}
          // workflowQuery={this.state.workflow_name}
          // previousQuery={this.state.previousQuery}
        />
      );
    } else if (message.type == "adyaActions") {
      // console.log("message.type adyaActions: ", message.msg.actions);
      return (
        <Message
          speaks={message.speaks}
          adyaActions={message.msg.actions}
          // actions={message.msg.actions}
          // previousQuery={this.state.previousQuery}
        />
      );
    } else if (message.type == "menu") {
      // console.log("onClickGuidedMenuHandler:", this.onClickGuidedMenuHandler);
      return (
        <Message
          type={message.type}
          speaks={message.speaks}
          onCallback={this.onClickGuidedMenuHandler}
          // workflow trigger
          // onTriggerWorkflow={this.onClickTriggerWorkflow}
          //Faq Menu
          onCallFaqMenu={this.faqMenuHandler}
          menuData={message?.msg?.data ?? {}}
          createMessage={this.createMessage}
          from="adya@hermes"
          font={this.state.isfontSize}
        />
      );
    } else if (message.type == "quickmenu") {
      return (
        <Message
          type={message.type}
          speaks={message.speaks}
          // Callback function to start the workflow/demo texts
          onCallback={this.onClickQuickMenuHandler}
          onTriggerWorkflow={this.onClickTriggerWorkflow}
          onCallFaqMenu={this.faqMenuHandler}
          onCallUpcomingMessage={this.onSendUpcomingMessage}
          quickmenuData={message.msg.data}
          createMessage={this.createMessage}
          fontsize={this.state.isfontSize}
        />
      );
    } else if (message.type == "herocard") {
      return (
        <Message
          type={message.type}
          speaks={message.speaks}
          // onCallback={this.onClickGuidedMenuHandler}
          // from="bot@hermes"
          from="adya@hermes"
          herocardData={message.msg.data}
          createMessage={this.createMessage}
        />
      );
    } else if (message.type == "agrlink") {
      return (
        <Message
          type={message.type}
          speaks={message.speaks}
          // onCallback={this.onClickGuidedMenuHandler}
          // from="bot@hermes"
          from="adya@hermes"
          herocardData={message.msg.data}
          createMessage={this.createMessage}
        />
      );
    } else if (message.type == "faqmenu") {
      return (
        <Message
          type={message.type}
          speaks={message.speaks}
          from="adya@hermes"
          faqMenuData={message.msg.data}
          createMessage={this.createMessage}
        />
      );
    } else if (message.type == "UserPreferenceModal") {
      return <Message speaks={message.speaks} from="adya@hermes" />;
    } else if (message.type == "advertisement") {
      console.log("adsData from advertisement type: ", message.msg.data);
      return (
        <Message
          type={message.type}
          speaks={message.speaks}
          adsData={message.msg.data}
          createMessage={this.createMessage}
        />
      );
    } else if (message.type == "otp") {
      // console.log("workflow: ", message.msg.data);
      return (
        <Message
          type={message.type}
          // text={message.msg.data.BODY.data}
          speaks={message.speaks}
          // otpworkflow={this.otpworkflow}
          // language={this.state.selectedLanguage}
          workflowDataHandler={this.df_text_query}
          // createMessage={this.createMessage}
          // onSendWorkflowDateOfBirth={this.onSendWorkflowData}
          // onSendWorkflowCifDateOfBirth={this.onSendWorkflowData}
          // onSendWorkflowSelectedAccount={this.onSendWorkflowData}
          // onSendChequeBookFormData={this.onSendWorkflowData}
          // accountListNoData={this.onGetAccountListNoData}
        />
      );
    } else if (message.type == "mobile") {
      // console.log("workflow: ", message.msg.data);
      return (
        <Message
          type={message.type}
          // text={message.msg.data.BODY.data}
          speaks={message.speaks}
          // otpworkflow={this.otpworkflow}
          // language={this.state.selectedLanguage}
          workflowDataHandler={this.df_text_query}
          // createMessage={this.createMessage}
          // onSendWorkflowDateOfBirth={this.onSendWorkflowData}
          // onSendWorkflowCifDateOfBirth={this.onSendWorkflowData}
          // onSendWorkflowSelectedAccount={this.onSendWorkflowData}
          // onSendChequeBookFormData={this.onSendWorkflowData}
          // accountListNoData={this.onGetAccountListNoData}
        />
      );
    } else if (message.type == "workflow") {
      // console.log("workflow: ", message.msg.data);
      return (
        <Message
          type={message.type}
          text={message.msg.data.BODY.data}
          speaks={message.speaks}
          language={this.state.selectedLanguage}
          workflowData={message.msg.data}
          createMessage={this.createMessage}
          onSendWorkflowDateOfBirth={this.onSendWorkflowData}
          onSendWorkflowCifDateOfBirth={this.onSendWorkflowData}
          onSendWorkflowSelectedAccount={this.onSendWorkflowData}
          onSendChequeBookFormData={this.onSendWorkflowData}
          accountListNoData={this.onGetAccountListNoData}
        />
      );
    } else if (message.type == "agr") {
      // console.log("workflow: ", message.msg.data);
      return (
        <Message
          type={message.type}
          text={message.msg.data.data.MESSAGE.RESULT[0].BODY.options}
          speaks={message.speaks}
          workflowData={message.msg.data}
          createMessage={this.createMessage}
          onSendWorkflowDateOfBirth={this.onSendAgrWorkflowData}
          onSendWorkflowCifDateOfBirth={this.onSendAgrWorkflowData}
          onSendWorkflowSelectedAccount={this.onSendAgrWorkflowData}
          onSendChequeBookFormData={this.onSendAgrWorkflowData}
          accountListNoData={this.onGetAccountListNoData}
        />
      );
    } else if (message.type == "ste") {
      // console.log("workflow: ", message.msg.data);
      return (
        <Message
          type={message.type}
          // text={message.msg.data.data.MESSAGE.RESULT[0].BODY.options}
          speaks={message.speaks}
          workflowData={message.msg.data}
          createMessage={this.createMessage}
          generatesteDrflowData={this.generatesteDrflowData}
          accountListNoData={this.onGetAccountListNoData}
        />
      );
    }
    else if (message.type == "scp_form") {
      // console.log("workflow: ", message.msg.data);
      return (
        <Message
          type={message.type}
          onSendSCPWorkFlowData={this.onSendSCPWorkFlowData}
          // text={message.msg.data.data.MESSAGE.RESULT[0].BODY.options}
         
        />
      );
    } 
     else if (message.type == "agrDp") {
      // console.log("workflow: ", message.msg.data);
      return (
        <Message
          type={message.type}
          text={message.msg.data}
          speaks={message.speaks}
          workflowData={message.msg.data}
          createMessage={this.createMessage}
          onSendWorkflowDatePicker={this.onSendWorkflowDatePicker}
          onSendWorkflowCifDateOfBirth={this.onSendWorkflowDatePicker}
          onSendWorkflowSelectedAccount={this.onSendWorkflowDatePicker}
          onSendChequeBookFormData={this.onSendWorkflowDatePicker}
          accountListNoData={this.onGetAccountListNoData}
        />
      );
    } else if (message.type == "agrDr") {
      // console.log("workflow: ", message.msg.data);
      return (
        <Message
          type={message.type}
          text={message.msg.data}
          speaks={message.speaks}
          workflowData={message.msg.data}
          createMessage={this.createMessage}
          handleSendWorkflowDateRange={this.handleSendWorkflowDateRange}
          onSendWorkflowCifDateOfBirth={this.handleSendWorkflowDateRange}
          onSendWorkflowSelectedAccount={this.handleSendWorkflowDateRange}
          onSendChequeBookFormData={this.handleSendWorkflowDateRange}
          accountListNoData={this.onGetAccountListNoData}
        />
      );
    } else if (message.type == "adya_nlp") {
      return (
        <Message
          type={message.type}
          speaks={message.speaks}
          adyanlpData={message.msg.data}
          adyaNlpQuery={message.msg.userQuery}
          createMessage={this.createMessage}
        />
      );
    }
    this.scrollToBottom();
  }

  setmicBusy(micStatus) {
    this.setState({ micBusy: micStatus });
  }

  // _handleInputKeyPress(e) {
  //   if (e.key === "Enter" && e.target.value != "") {
  //     this.df_text_query(e.target.value);
  //     this.setState({
  //       inputHistory: [...this.state.inputHistory, e.target.value],
  //     });
  //     this.setState({ inputPointer: this.state.inputHistory.length });
  //     e.target.value = "";
  //     this.setState({ userInput: "" });
  //   }
  // }
  _handleInputKeyPress(e) {
    if (e.key === "Enter" && e.target.value.trim() === "") {
      // this.setMessages(generateTextMessageData(" Please do ask me a query 😃"));
      this.setState({
        inputValue: "",
      });
    } else if (e.key === "Enter" && e.target.value != "") {
      this.df_text_query(e.target.value);
      this.setState({
        inputHistory: [...this.state.inputHistory, e.target.value],
        // chatBOTFooterDisable: true,
      });
      this.setState({ inputPointer: this.state.inputHistory.length });
      e.target.value = "";
      this.setState({ inputValue: "" });
    } else if (e.key === "Enter" && e.target.value == "") {
      return;
    }
  }
  _handleKeyUp(e) {
    if (e.key == "ArrowUp") {
      if (
        this.state.inputHistory.length > 0 &&
        this.state.inputPointer < this.state.inputHistory.length - 1
      ) {
        e.target.value = this.state.inputHistory[this.state.inputPointer + 1];
        this.setState({ inputPointer: this.state.inputPointer + 1 });
      }
    } else if (e.key == "ArrowDown") {
      if (this.state.inputHistory.length > 0 && this.state.inputPointer >= 0) {
        e.target.value = this.state.inputHistory[this.state.inputPointer];
        this.setState({ inputPointer: this.state.inputPointer - 1 });
      }
    }
  }

  // _handleSendButton(e) {
  //   if (this.state.userInput != "") {
  //     this.df_text_query(this.state.userInput);
  //   }
  //   this.setState({ userInput: "" });
  // }

  _handleSendButton(e) {
    this.setState({
      // inputHistory: [...this.state.inputHistory, e.target.value],
      chatBOTFooterDisable: true,
    });
    if (this.state.inputValue != "") {
      this.df_text_query(this.state.inputValue);
    }
    this.setState({ inputValue: "" });
  }

  // onhandleSendButton() {
  //   if (this.state.userInput != "") {
  //     this.df_text_query(this.state.userInput);
  //   }
  //   //reset user input after sending message
  //   this.onResetInputField();
  // }

  onhandleSendButton() {
    if (this.state.inputValue != "") {
      this.setState({
        // inputHistory: [...this.state.inputHistory, e.target.value],
        chatBOTFooterDisable: false,
      });
      // if (this.state.inputValue != "") {
      this.df_text_query(this.state.inputValue);
    }
    //reset user input after sending message
    this.onResetInputField();
  }

  // onResetInputField() {
  //   this.setState({ userInput: "" }, function () {});
  // }
  onResetInputField() {
    this.setState({ inputValue: "" }, function () {});
  }

  bot_event_handler(socket) {
    socket.on("agr_response", (response) => {
      console.log("reponse recieved", response);
      this.createMessage(response);
    });
  
    socket.on("bot_message", (response) => {
      debugger
     
      if (response.status !== 200) {
        this.setMessages(
          generateTextMessageData(
            `Sorry We Were Unable to Connect. Please Try Again After Some Time`
          )
        );
        return;
      }

      try {
        if (response.data.MESSAGE.RESULT.BODY != undefined) {
          this.setMessages(
            generateTextMessageData(response.data.MESSAGE.RESULT.BODY)
          );
        }
        {
          this.setState({ loadingDots: false, tempImpMsg: "" });
        }

        for (let i = 0; i < response.data.MESSAGE.RESULT.length; i++) {
          if (response.data.MESSAGE.RESULT.length > 0) {
            setTimeout(
              function () {
                this.createMessage(
                  response.data.MESSAGE.RESULT[i],
                  response.data.MESSAGE.INTENT_FLAG,
                  response.data.MESSAGE.QUERY,
                  response
                );
              }.bind(this),
              i * 1000
            );
          } else {
            this.createMessage(
              response.data.MESSAGE.RESULT[i],
              response.data.MESSAGE.INTENT_FLAG,
              response.data.MESSAGE.QUERY
            );
          }
        }
      } catch (err) {
        this.createMessage(
          response.data.MESSAGE.RESULT,
          response.data.MESSAGE.INTENT_FLAG
        );
      }
    });
    // socket.on("EBC_account_list", (response) => {
    //   if (
    //     response.status === "custom_message" &&
    //     this.state.hasagrstarted === false
    //   ) {
    //     if (this.state.selectedLanguage === "en") {
    //       this.setMessages(generateTextMessageData(response.message));
    //     } else if (this.state.selectedLanguage === "hn") {
    //       this.setMessages(
    //         generateTextMessageData("कृपया नीचे अपनी शिकायत दर्ज करें")
    //       );
    //     } else if (this.state.selectedLanguage === "od") {
    //       this.setMessages(
    //         generateTextMessageData(
    //           "ଦୟାକରି ନିମ୍ନରେ ଆପଣଙ୍କର ଅଭିଯୋଗ ପ୍ରବେଶ କରନ୍ତୁ |"
    //         )
    //       );
    //     }

    //     this.setState({ hasagrstarted: true });
    //     return;
    //   }
    // });
    socket.on("bot_text_message", (data) => {
      this.setMessages(generateTextMessageData(data.text));
    });

    socket.on("bot_workflow_error_message", (response) => {
      /**
       * workflow error message
       *  => Send Response according to the status sent from the backend
       *
       *  => if 500: "Sorry We Were Unable To Get A Response From the     APIs. Please Terminate and Try After Sometime"
       *  => if !200 && !500: "Sorry!! Something Went Wrong."
       */
      this.setMessages(
        generateTextMessageData(
          `Sorry We Were Unable to Connect. Please Try Again After Some Time`
        )
      );
    });

    socket.on("error_message", (data) => {
      // console.warn(`error message => ${data.response}`);
      this.setMessages(
        generateTextMessageData(
          "Sorry I Could Not Understand The Query. Could You Please Rephrase It"
        )
      );
    });

    //Socket to handle adya_nlp_error_message
    socket.on("adya_nlp_error_message", (data) => {
      this.setState({ loadingDots: false });
      // console.log("adya nlp error message: ", data);
      if (data.status === 403) {
        // this.setMessages(
        //   generateTextMessageData(
        //     "Sorry I Could Not Understand Your Query. Could You Please Rephrase It"
        //   )
        // );
        this.setMessages(generateTextMessageData(data.response));
      } else {
        this.setMessages(generateTextMessageData(data.response));
      }
    });

    /**
     * 1. socket to end the workflow
     */

    socket.on("hard_exit", (response) => {
      let workflow_status = this.setWorkflowState(false);
      let setFooterState = this.setChatBOTFooterState(false);
      // this.setMessages({JumpingDots:false})
      console.log(this.state.loadingDots);

      if (response.status === 202) {
        this.setMessages(
          generateTextMessageData(response.data.MESSAGE.RESULT.BODY.data)
        );
      } else if (response.status === 500) {
        this.setMessages(generateTextMessageData(response.message));
      }
      this.setState({ loadingDots: false });
    });

    // socket.on("video_call_request", (data) => {
    //   // console.log("Video call requested!", data);
    //   //Delete Existing Session
    //   this.props.deleteVideofloSession();
    //   //trigger videoflo-webcomponent using redux
    //   setTimeout(
    //     function () {
    //       this.props.createVideofloSession(data.messageData);
    //     }.bind(this),
    //     200
    //   );
    // });

    // socket.on("human_connected", (data) => {
    //   this.setMessages(
    //     generateTextMessageData(`You are connected with ${data.agent.fname}`)
    //   );
    //   this.setState({ Human_connected: true });
    // });

    // socket.on("human_reconnect", (data) => {
    //   this.setMessages(
    //     generateTextMessageData(
    //       `Connection re-established with ${data.agent.fname}`
    //     )
    //   );
    //   this.setState({ Human_connected: true });
    // });

    // socket.on("human_reject", (data) => {
    //   this.setMessages(generateTextMessageData(data.text));
    //   this.setState({ Human_connected: false });
    // });

    // socket.on("human_talk", (data) => {
    //   this.setMessages(data.messageData);
    // });

    // socket.on("issue_closed", (conversation_id) => {
    //   this.setState({ Human_connected: false });
    //   this.setMessages(
    //     generateTextMessageData(
    //       `Operator closed the current issue. Hope your issue got resolved!`
    //     )
    //   );
    //   this.props.deleteVideofloSession();
    //   //Ask for feedback
    //   //TODO
    // });

    // socket.on("issue_closed_by_client", (conversation_id) => {
    //   this.setState({ Human_connected: false });
    //   this.setMessages(
    //     generateTextMessageData(`Done! Previous agent request got closed.`)
    //   );
    //   this.props.deleteVideofloSession();
    //   //Ask for feedback
    //   //TODO
    // });

    // socket.on("client_disconnect", (data) => {
    //   this.setState({ Human_connected: false });
    //   this.setMessages(generateTextMessageData(data.text));
    // });

    // socket.on("Human_disconnected", (data) => {
    //   this.setMessages(generateTextMessageData(`You are Disconnected!`));
    //   this.setState({ Human_connected: false });
    // });
    this.props.deleteVideofloSession();
    // console.log("Handlers registered..!!");
  }

  componentDidMount() {
    console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^6 ",this.state)
    this.setState({ footerBackground: true });
    this.getFeedback();
    this.bot_event_handler(socket1);
    this.setState({ is_mounted: true });
    document.addEventListener("contextmenu", this.disableRightClick);
    // window.addEventListener('message', this.onMessageHandler);
    // Advertisement Card

    this.setWelcomeAds();
    // Onboarding Welcome Message
    this.setBotGreeting();
    // this.setWelcomeMessage("en");
    // func to call quick menu
    // func to call the floating menu
    // setTimeout(() => {
    //   this.setFloatingWelcomeMenu("en");

    // }, 1000);

    this.setFloatingQuickMenu("en");
    // this.getFeedback();
    this.setState({ firstload: true });
    //logUserVisit

    this.setUserVisit();
    eventBus.on('escp_form_data', this.onSendSCPWorkFlowData);
  //   this.eventEmitter.on('scp_form_submit', (data) => {
  //   this.onSendSCPWorkFlowData(data)
  // })
  // EventBus.on('scp_form_submit', this.onSendSCPWorkFlowData);
  }

  shouldComponentUpdate(p, s) {
    console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ shouldComponentUpdate",p,s);
    return true;
  }

  componentDidUpdate(pp, ps) {
    console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^666 componentDidUpdate",pp,ps);
    this.scrollToBottom();
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.onMessageHandler);
    this.setState({ is_mounted: false });
    eventBus.off('escp_form_data', this.onSendSCPWorkFlowData);

    document.removeEventListener("contextmenu", this.disableRightClick);

  }

  //this handler will be pass to ComfirmModal
  async onConfirm() {
    try {
      //Send Transcript
      // await sendTranscript();
    } catch (err) {
    } finally {
      //clearTrancript
      // deleteTranscript();
      //Finally close modal
      // this.props.toggleConfirmModal(false);
      //post message from child to parent
      //send event from child component to seperate component like iframe
      // var botMessage = "CLOSECHAT";
      // window.parent.postMessage(botMessage, "*");
      //create new session (No need if login required)
      // this.props.createSession()
      //create welcome message
      // this.refeshChatbot();
      //Cleare Sessioon Storage
      // clearSessionStorageData();
      //Reload Page
      // window.location.reload(false);
      //resetLoginStatus
      // this.props.resetLoginStatus();
      //minimize chatbot
      // this.props.update_botStatus_inactive();
    }
  }

  async onCancel() {
    this.props.toggleConfirmModal(false);
  }

  render() {
    const {
      isfontSize,
      isDarkMode,
      inputValue,
      suggestions,
      selectedSuggestionIndex,
    } = this.state;

    const { isScrollToTop } = this.state;
    const limitedSuggestions = suggestions.slice(0, 5);
    return (
      <React.Fragment>
        <div
          id="chatbot-root"
          className={`chatbot-Wrapper active ${
            this.state.footerBackground
              ? this.state.isDarkMode
                ? "greeting-active-dark"
                : "greeting-active"
              : ""
          }`}
        ></div>
        {this.state.isRateModalActive && (
          <ConfirmModal
            onConfirm={this.onConfirm}
            onMinimize={function () {
              this.props.update_botStatus_inactive();
              this.props.toggleConfirmModal(false);
            }.bind(this)}
            onCancel={function () {
              // console.log("onCancel clicked");
              // this.props.toggleConfirmModal(false);
              this.setState({ isRateModalActive: false });
            }.bind(this)}
          ></ConfirmModal>
        )}
        {this.state.refreshConfirmOpen && (
          <RefreshConfirmModal
            onRefreshConfirm={this.onRefreshConfirm}
            onRefreshCancel={this.onRefreshCancel}
            // onMessage={[`Do you like to reload?", "Please confirm if you want to reload the chatbox.<br> Please note that this may result in the loss of your current session’s chat data.`]} // Send messages as an array

            // onConfirm={this.onConfirm}
            // onMinimize={function () {
            //   this.props.update_botStatus_inactive();
            //   this.props.toggleConfirmModal(false);
            // }.bind(this)}
            // onCancel={function () {
            //   // console.log("onCancel clicked");
            //   // this.props.toggleConfirmModal(false);
            //   this.setState({ refreshConfirmOpen: false });
            // }.bind(this)}
          />

          // ></RefreshConfirmModal.>
        )}
        {this.state.ConfirmUserPreference && (
          <UserSelectorModal
            onRefreshConfirm={this.onUserPreferenceConfirm}
            onRefreshCancel={this.onUserPreferenceCancel}
            onMessage={[
              "Do you want to change the user preference? The current data will be lost",
            ]} // Send messages as an array

            // onConfirm={this.onConfirm}
            // onMinimize={function () {
            //   this.props.update_botStatus_inactive();
            //   this.props.toggleConfirmModal(false);
            // }.bind(this)}
            // onCancel={function () {
            //   // console.log("onCancel clicked");
            //   // this.props.toggleConfirmModal(false);
            //   this.setState({ refreshConfirmOpen: false });
            // }.bind(this)}
          />

          // ></RefreshConfirmModal.>
        )}

        {this.state.languageModalIsOpen && (
          <UserPreference onLanguageSelect={this.handleLanguageSelect} />
        )}
        {/* Rendering bubble till response form backend is received */}

        {/* Language selection model */}
        {/* {this.state.languageSelector && (
            <LanguageSelector
            onConfirm={this.onConfirm}
            onMinimize={function () {
              this.props.update_botStatus_inactive();
              this.props.toggleConfirmModal(false);
            }.bind(this)}
            onCancel={function () {
              // console.log("onCancel clicked");
              // this.props.toggleConfirmModal(false);
              this.setState({isRateModalActive: false})
            }.bind(this)}
          ></LanguageSelector>
          )
          } */}
        {/* <div className="chatbot-Wrapper effect8 z-depth-5"> */}
        {/* <ChatBotHeader
          update_botStatus_inactive={this.props.update_botStatus_inactive}
          toggleChatWindowSize={this.props.toggleChatWindowSize}
          refeshChatbot={this.refeshChatbot}
          logInData={this.props.logInData}
          generateSpeech={this.generateSpeech}
        /> */}

        <div
          id={isDarkMode ? "chatbot-dark" : "chatbot"}
          className={this.props.isLogIn ? "" : "logIn_form"}
          ref="chat_box_ref"
          disabled={this.state.openMenu}
        >
          {this.props.isLogIn ? (
            <React.Fragment>
              {/* {this.props.isTyping && <Message typingBubble={true} speaks="bot"></Message>} */}
              {this.renderMessage(this.state.adsDataList)}
              {this.renderMessage(this.state.messages)}
              {this.renderMessage(this.state.customMessages)}
              {this.props.isTyping && this.renderTempMessage()}
              <div ref="last_chat_message" />
              {this.state.loadingDots && (
                <Message
                  speaks="bot"
                  loadingDots={this.state.loadingDots}
                  tempImpMsg={this.state.tempImpMsg}
                  scrollToBottom={this.scrollToBottom}
                />
              )}

              <button
                className={isDarkMode ? "scroller-dark" : "scroller"}
                title="Scroll"
              >
                {isScrollToTop ? (
                  <ArrowDropDownIcon
                    htmlColor="#fff"
                    onClick={this.handleScrollButtonClick}
                    style={{ height: "16px", width: "16px" }}
                  />
                ) : (
                  <ArrowDropUpIcon
                    htmlColor="#fff"
                    onClick={this.handleScrollButtonClick}
                    style={{ height: "16px", width: "16px" }}
                  />
                )}
              </button>
            </React.Fragment>
          ) : (
            <LoginForm></LoginForm>
          )}
        </div>

        {/* ChatBOT Footer */}
        {this.state.chatBOTFooterDisable == false && (
          <div
            className={
              this.props.logInData.isLogIn
                ? isDarkMode
                  ? "input-wrapper-dark top-only-shadow"
                  : "input-wrapper top-only-shadow"
                : "input-wrapper top-only-shadow disabled"
            }
          >
            {/* {this.props.isTyping == false && (
              <LanguageSelection
                setUserInput={this.setUserInput}
              ></LanguageSelection>
            )} */}

            {/* {(this.state.micBusy) ? ( */}
            {this.props.isTyping || this.state.micBusy ? (
              // <p className="chatbotInputBox">{this.state.micBusy? <>Listning......</>: <JumpingDots noOfDots='3'></JumpingDots>}</p>
              <p className="chatbotInputBox">
                {this.state.micBusy && (
                  <>
                    {this.props.botType.language == "en"
                      ? "Listening..."
                      : "कृपया पूंछें......"}
                  </>
                )}
              </p>
            ) : (
              <div
                className={
                  isDarkMode ? "chatbotInputBox-dark" : "chatbotInputBox"
                }
              >
                {/* <AutoSuggestedInput
                  df_text_query={this.df_text_query}
                  setUserInput={this.setUserInput}
                  _handleSendButton={this._handleSendButton}
                  onKeyPress={this._handleInputKeyPress}
                  className="input-box"
                  onKeyUp={this._handleKeyUp}
                  isDialog={this.state.workflow_status}
                /> */}

                <input
                  autoFocus
                  className={isDarkMode ? "input-box-dark" : "input-box"}
                  type="text"
                  maxLength={500}
                  value={this.state.inputValue}
                  onKeyPress={this._handleInputKeyPress}
                  onChange={this.setUserInput}
                  onKeyUp={this._handleKeyUp}
                  disabled={this.props.isTyping || this.state.openMenu}
                  onClick={this.handleInputClick}
                  // placeholder="Type your message here"
                  placeholder={
                    this.state.selectedLanguage === "en"
                      ? "Type your message here"
                      : this.state.selectedLanguage === "hn"
                      ? "अपना संदेश यहाँ टाइप करें"
                      : this.state.selectedLanguage === "od"
                      ? "ଏଠାରେ ଆପଣଙ୍କ ସନ୍ଦେଶ ଲେଖନ୍ତୁ"
                      : "Type your message here"
                  }
                  ref="botInput"
                ></input>
                {this.state.showPopup && (
                  <div className="modal">
                    <div className="modal-content">
                      <p className="modal-text">
                        {this.state.selectedLanguage === "en"
                          ? "Do you have a complaint?"
                          : this.state.selectedLanguage === "hn"
                          ? "क्या आपकी कोई शिकायत है?"
                          : this.state.selectedLanguage === "od"
                          ? "ଆପଣଙ୍କର ଅଭିଯୋଗ ଅଛି କି?"
                          : "Do you have a complaint?"}
                      </p>
                      <div>
                        <button
                          className="modal-button"
                          onClick={this.handleYesClick}
                        >
                          {this.state.selectedLanguage === "en"
                            ? "Yes"
                            : this.state.selectedLanguage === "hn"
                            ? "हाँ"
                            : this.state.selectedLanguage === "od"
                            ? "ହଁ"
                            : "Yes"}
                        </button>
                        <button
                          className="modal-button"
                          onClick={this.handleNoClick}
                        >
                          {this.state.selectedLanguage === "en"
                            ? "No"
                            : this.state.selectedLanguage === "hn"
                            ? "नहीं"
                            : this.state.selectedLanguage === "od"
                            ? "ନା"
                            : "No"}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                {/* {suggestions.length > 0 && (
          <ul className="suggestions">
            {limitedSuggestions.map((suggestion, index) => (
              <li
                key={index}
                className={index === selectedSuggestionIndex ? 'selected' : ''}
                onClick={() => this.handleSelect(suggestion)}
              >
                {suggestion}
                      </li>
                    ))}
                  </ul> 
                )} */}
              </div>
            )}

            {/* {true && (<button> &#127908;</Icon>)} */}
            {/* <div class="mic-wrapper">
              {this.props.isTyping == false && (
                <SpeechToText
                  setmicBusy={this.setmicBusy}
                  send_text_to_bot={(text) => this.df_text_query(text)}
                ></SpeechToText>
              )}
            </div> */}
            {/* disabl input s */}

            {this.props.isTyping == false && (
              <div
                className={
                  isDarkMode
                    ? "send-button-wrapper-dark"
                    : "send-button-wrapper"
                }
                onClickCapture={this.onhandleSendButton}
                disabled={this.state.micBusy}
              >
                <span disabled={this.props.isTyping || this.state.openMenu}>
                  <i className="material-icons dp48">send</i>
                </span>
              </div>
            )}
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    update_botStatus_inactive: () => {
      dispatch(update_botStatus_inactive);
    },
    update_botStatus_active: () => {
      dispatch(update_botStatus_active);
    },
    update_botTyping_to_true: () => {
      dispatch(update_botTyping_to_true);
      //    setTimeOut(() =>   dispatch(update_botTyping_to_true) , 3000)
    },
    update_botTyping_to_false: () => {
      dispatch(update_botTyping_to_false);
      // this.props.setTimeOut(() =>   dispatch(update_botTyping_to_false) , 3000)
    },

    bot_message_added: () => {
      dispatch(bot_message_added);
    },
    set_talk_to_what: (talk_to) => {
      dispatch({ type: "TALK_TO_WHAT_ACTION", payload: talk_to });
    },
    set_table_list_data: (tableData) => {
      dispatch({ type: "TABLE_DATA_ACTION", payload: tableData });
    },

    open_modal: (type, url) => {
      dispatch({ type: "MODAL_TYPE_ACTION", payload: type });
      dispatch({ type: "MODAL_URL_ACTION", payload: url });
      dispatch(open_modal);
    },

    set_conversation_id: (id) => {
      dispatch({ type: "CONVERSATION_ID_ACTION", payload: id });
    },
    set_group_id: (id) => {
      dispatch({ type: "GROUP_ID_ACTION", payload: id });
    },
    set_to_participantID: (id) => {
      dispatch({ type: "TO_PARTICIPANT_ID_ACTION", payload: id });
    },
    set_from_participantID: (id) => {
      dispatch({ type: "FROM_PARTICIPANT_ID_ACTION", payload: id });
    },
    set_leaveFormData: (formData) => {
      dispatch({ type: "LEAVE_FORM_DATA_INITIALIZATION", payload: formData });
    },
    toggleConfirmModal: (status) => {
      dispatch({ type: "UPDATE_COMFIRM_MODAL", payload: status });
    },
    resetLoginStatus: () => {
      dispatch({ type: "LOGOUT_ACTION", payload: "" });
    },
    createVideofloSession: (payload) => {
      dispatch({ type: CREATE_VIDEOFLO_SESSION, payload });
    },
    deleteVideofloSession: () => {
      dispatch({ type: DELETE_VIDEOFLO_SESSION });
    },
    // nlp_query
    set_user_query_nlp: (query) => {
      dispatch({ type: ADYA_USER_QUERY_ACTION, payload: query });
    },
  };
};

const mapStateToProps = (state) => {
  return {
    isOpened: state.botStatus.isOpened,
    botMessagesLength: state.botMessagesLength.length,
    isTyping: state.isTyping.isTyping,
    talk_to_what: state.talk_to_what.name,
    isLogIn: state.logInStatus.isLogIn,
    userType: state.logInStatus.userType,
    logInData: state.logInStatus,
    sesstionDetails: state.sessionDetails,
    botType: state.botType,
    confirmModal: state.confirmModal,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Chatbot_Talk_To_Bot);
